var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandFam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-parents",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-parents:not(.animated) .animable {opacity: 0;}svg#freepik_stories-parents.animated #freepik--background-complete--inject-25 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }        .animator-hidden { display: none; }")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-25",
    className: "animable animator-hidden animator-active",
    style: {
      transformOrigin: "239.169px 252.333px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "308.11 376.05 284.8 477.29 294.65 477.27 318.02 377.01 308.11 376.05",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "301.41px 426.67px"
    },
    id: "eldzk1kvhgjv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.65 376.05 374.05 477.29 383.41 477.29 360.77 376.05 350.65 376.05",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "367.03px 426.67px"
    },
    id: "el37koiqeyzgn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "292.37 300.02 305.65 369.72 320.74 369.72 306.56 300.02 292.37 300.02",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "306.555px 334.87px"
    },
    id: "elh9m38q19xjp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.14 376.05 42.13 477.29 51.81 477.29 71.67 376.05 61.14 376.05",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "56.9px 426.67px"
    },
    id: "eldh6kug8vgr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.14 376.05 122.88 476.74 132.44 476.74 111.45 376.05 101.14 376.05",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "116.79px 426.395px"
    },
    id: "elfxi9dlhx6bo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.41 300.02 58.68 369.72 73.77 369.72 59.59 300.02 45.41 300.02",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "59.59px 334.87px"
    },
    id: "ele548g6mfgn4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "15.53 293.68 18.25 306.35 321.19 306.35 317.65 293.68 15.53 293.68",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "168.36px 300.015px"
    },
    id: "elseo0mwwwlz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.32 318.29 24.52 330.96 325.41 330.96 322.67 318.29 21.32 318.29",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "173.365px 324.625px"
    },
    id: "elorgp3ny0a1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "27.3 343.77 30.28 356.44 330.24 356.44 327.4 343.77 27.3 343.77",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "178.77px 350.105px"
    },
    id: "elekr72mt36s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.23,
    y: 369.72,
    width: 323.45,
    height: 12.67,
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "211.955px 376.055px"
    },
    id: "el7851tzvfdlx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.17,309.79c-21-5.48-39.29-19.27-49.49-37.24a71.69,71.69,0,0,1-5.19-59.16c5.41-15,15.82-28.3,20.29-43.61,5.07-17.39,2.05-35.83-1.08-53.61S355.38,80,360.13,62.55s19.72-33.86,39-35.1c17.85-1.15,34.34,11.2,41.79,26.4s7.49,32.61,5.75,49.25-5.13,33.24-4.06,49.92c2.16,33.77,22.41,65.56,20,99.32-1.24,17.58-8.52,28.83-21,42-10.75,11.4-28.61,18.89-44.44,15.4",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "400.603px 168.989px"
    },
    id: "elpxmghm8baa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.49,477.12c-.19,0-.34-74.81-.34-167.07s.15-167.1.34-167.1.34,74.8.34,167.1S403.67,477.12,403.49,477.12Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "403.49px 310.035px"
    },
    id: "elf6e821sy2id",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.52,251.41a25.05,25.05,0,0,1-3.08-2.72c-1.84-1.74-4.34-4.2-7-7s-5.05-5.29-6.8-7.11a25.82,25.82,0,0,1-2.74-3,25.5,25.5,0,0,1,3.09,2.72c1.83,1.74,4.33,4.2,7,7s5,5.29,6.8,7.11A25.82,25.82,0,0,1,402.52,251.41Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "392.71px 241.495px"
    },
    id: "elxgjtrw53fl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.56,
    y: 463.25,
    width: 111.74,
    height: 13.65,
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "404.43px 470.075px"
    },
    id: "elb9bm1e7c11n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.54,181.41a23.06,23.06,0,0,0,6.82-2.84,18.89,18.89,0,0,0,5.48-5.51,18.43,18.43,0,0,0,3-8.73q0-.17,0-.3l.39.33a14.69,14.69,0,0,0-8.23,4.52,31.15,31.15,0,0,0-4.58,6.15c-1.1,1.89-1.87,3.47-2.4,4.57a11.56,11.56,0,0,1-.85,1.7,9.19,9.19,0,0,1,.61-1.79,42.11,42.11,0,0,1,2.22-4.68,29.46,29.46,0,0,1,4.54-6.34,15.15,15.15,0,0,1,8.59-4.76l.42-.06,0,.39,0,.31a19,19,0,0,1-8.86,14.56,17.24,17.24,0,0,1-5.08,2.16,13.74,13.74,0,0,1-1.49.28A2,2,0,0,1,404.54,181.41Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "412.36px 172.543px"
    },
    id: "elyr0lwlfwh7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.54,181.41c-.15-.11,1.95-2.72,4.68-5.82s5-5.53,5.2-5.42-1.95,2.71-4.68,5.82S404.68,181.52,404.54,181.41Z",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "409.483px 175.79px"
    },
    id: "el8g0sx37mfb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.29,58.78c.59-4.28-5.45-7.8-10-8.16-2.17-.18-4.41.15-6.46-.56-4.44-1.55-6.22-7.29-10.55-9.11-3.24-1.37-7-.15-10.11,1.43S228,46,224.44,46.17c-3.05.2-6.37-.93-9,.56-2,1.11-3,3.4-4.87,4.75s-4.13,1.6-6.36,1.73-4.53.14-6.56,1.07-3.7,3.07-3.28,5.26Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "232.817px 49.948px"
    },
    id: "el2eyoor0cohv",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.91,126.1c.61-4.44-5.65-8.09-10.35-8.47-2.25-.18-4.58.16-6.7-.58-4.61-1.6-6.45-7.55-10.94-9.45-3.36-1.41-7.23-.15-10.49,1.49s-6.47,3.7-10.11,3.93c-3.17.2-6.6-1-9.37.58-2.07,1.15-3.15,3.53-5,4.93s-4.29,1.66-6.6,1.79-4.7.15-6.8,1.11-3.84,3.19-3.4,5.46Z",
    style: {
      fill: "rgb(235, 235, 235)",
      transformOrigin: "237.016px 116.94px"
    },
    id: "el1rsjh2fmtbx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.78,90.46c.74-5.44-6.93-9.92-12.71-10.39-2.75-.22-5.61.2-8.21-.71-5.65-2-7.91-9.26-13.42-11.59-4.12-1.73-8.86-.19-12.86,1.82s-7.94,4.54-12.4,4.83c-3.88.25-8.1-1.19-11.5.7-2.53,1.42-3.85,4.33-6.19,6s-5.26,2-8.09,2.2-5.76.18-8.34,1.36-4.71,3.91-4.17,6.69Z",
    style: {
      fill: "rgb(245, 245, 245)",
      transformOrigin: "95.8177px 79.1951px"
    },
    id: "elaqf0p8gfucc",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-25",
    className: "animable",
    style: {
      transformOrigin: "251.863px 279.519px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.25,285.72a4.27,4.27,0,0,1-4.42,1.93,11.74,11.74,0,0,1-4.65-2.11c-1.42-.93-3-2.13-3-3.82a8.46,8.46,0,0,1,.66-2.72c.82-2.75.11-5.69-.4-8.51a38.76,38.76,0,0,1-.12-15.1,22.69,22.69,0,0,1,7.5-12.89A23.73,23.73,0,0,1,246.4,238c5.8-1.36,12.14-1,17.41,1.74s9.28,8.21,9.54,14.16c.19,4.27-1.23,9.3,1.79,12.33.92.91,2.14,1.48,3,2.41,2,2.09,2,5.64.37,8.08a11.94,11.94,0,0,1-7.16,4.64,20.31,20.31,0,0,1-10.8-.14",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "254.163px 262.478px"
    },
    id: "eln1g7lwm9hf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.87,265.28a6.85,6.85,0,0,1,1.85,4.13,16.55,16.55,0,0,0,1,4.49,3.83,3.83,0,0,0,3.58,2.43A14.21,14.21,0,0,1,262,282l-.57-18.05",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "269.365px 273.208px"
    },
    id: "elmq24uakr1m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.67,257.15c.3-6.08,6.76-12.25,12.83-11.7l19.71,3.45,0,3.28-.62,40.53h0s-1.5,13.09-12.54,12.5c-9.91-.52-9.52-11-9.52-11l.19-7.64s-8-.21-9.76-10.32C232.06,271.22,232.35,263.92,232.67,257.15Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "248.784px 275.323px"
    },
    id: "elf79ynme3anj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.43,265.06c.17.17,1.14-.58,2.54-.59s2.43.66,2.58.49-.09-.38-.54-.7a3.54,3.54,0,0,0-2.07-.6,3.41,3.41,0,0,0-2,.68C234.49,264.68,234.35,265,234.43,265.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "237.002px 264.372px"
    },
    id: "el9w73rtu40i4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.82,264.93c.17.16,1.14-.58,2.54-.6s2.43.67,2.58.5-.09-.38-.54-.7a3.61,3.61,0,0,0-2.07-.61,3.41,3.41,0,0,0-2,.69C247.88,264.54,247.74,264.85,247.82,264.93Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250.392px 264.236px"
    },
    id: "elm2gd0p50t5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.36,272a10.58,10.58,0,0,0-2.28-.33c-.36,0-.7-.08-.76-.29s.05-.55.21-.9l1-2.31c1.39-3.29,2.39-6,2.23-6.05A36.77,36.77,0,0,0,241,268c-.34.81-.66,1.58-1,2.32a1.51,1.51,0,0,0-.16,1.19.87.87,0,0,0,.6.44,2.84,2.84,0,0,0,.6.07A10.68,10.68,0,0,0,243.36,272Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "241.78px 267.097px"
    },
    id: "elmwvxnkn3mc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.64,286.63a25.79,25.79,0,0,0,13.52-3.82s-3.37,7.13-13.52,6.33Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "249.4px 286.006px"
    },
    id: "elraw5iprlfnn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.13,271.57c-.23,0-.21,1.51-1.49,2.61s-2.9.95-2.91,1.16.36.29,1.05.3a3.81,3.81,0,0,0,2.43-.89,3.28,3.28,0,0,0,1.15-2.18C247.41,271.93,247.24,271.56,247.13,271.57Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "245.049px 273.605px"
    },
    id: "eli4mc4n9pfw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.64,259c.19.48,1.55.1,3.21.19s3,.54,3.21.07c.08-.23-.2-.68-.79-1.11a4.56,4.56,0,0,0-2.46-.84,4.12,4.12,0,0,0-2.43.64C247.81,258.32,247.55,258.74,247.64,259Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250.848px 258.388px"
    },
    id: "elq6is3s9xprm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.5,258.81c.29.49,1.57.08,3.08.14s2.77.48,3.09,0c.15-.23,0-.71-.56-1.18a4.06,4.06,0,0,0-5-.12C234.57,258.11,234.37,258.58,234.5,258.81Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "237.593px 258.012px"
    },
    id: "eld3g30aquv5k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.46,264c.19-.08,7.74-2.11,7.33,5.54s-8,5.67-8,5.45S264.46,264,264.46,264Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "267.798px 269.539px"
    },
    id: "elz3rv49crzkc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.6,272.19s.13.11.35.22a1.35,1.35,0,0,0,1,.07c.82-.25,1.57-1.5,1.68-2.87a4.32,4.32,0,0,0-.27-1.93,1.51,1.51,0,0,0-.95-1.08.67.67,0,0,0-.8.32c-.12.21-.08.37-.12.38s-.16-.14-.08-.45a.82.82,0,0,1,.33-.46,1,1,0,0,1,.75-.16,1.88,1.88,0,0,1,1.33,1.26,4.48,4.48,0,0,1,.34,2.16c-.13,1.54-1,2.94-2.12,3.2a1.43,1.43,0,0,1-1.2-.27C265.61,272.38,265.58,272.21,265.6,272.19Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "267.387px 269.549px"
    },
    id: "elo7tjkl2cbtq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.41,244.16c.51-2.09,2.81-2.94,4.8-3.35,4.2-.88,8.57-1.35,12.74-.31a14.65,14.65,0,0,1,10,7.9c2.1,4.74,1.11,10.3.07,15.43l-2.74-.05c-1.05,4.31-6.42,3.75-7.36-1.62-.34-1.93-1.12-4.05-2.67-5.15a6.74,6.74,0,0,0-3.18-.82,14.42,14.42,0,0,1-11.14-8.81A5.32,5.32,0,0,1,240.41,244.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "254.768px 253.276px"
    },
    id: "eltxyne0u91hb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.91,249.41c-.47-.68.3-1.52,1-1.94a11.89,11.89,0,0,1,6.52-2A6.38,6.38,0,0,1,284,249a8.34,8.34,0,0,1,.6,2.94,6.41,6.41,0,0,1-.61,3.7,5.47,5.47,0,0,1-3.94,2.3,7.84,7.84,0,0,1-3.27-.13c-3.21-.88-5.16-4-6.81-6.91",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "277.314px 251.762px"
    },
    id: "elyji5ry32nf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.18,256.62c0,.34-1,.68-2.79.63a7,7,0,0,1-3.16-.91,7.83,7.83,0,0,1-1.54-1.21,10.05,10.05,0,0,1-1.32-1.6,11.1,11.1,0,0,1-1.35-3.64,15.37,15.37,0,0,1-.28-3c0-1.7.32-2.74.67-2.75s.71,1,1.15,2.5c.23.77.47,1.67.79,2.64a13.52,13.52,0,0,0,1.22,2.84,11.17,11.17,0,0,0,1,1.23,9,9,0,0,0,1,1,7.66,7.66,0,0,0,2.17,1.1C249.17,255.92,250.21,256.25,250.18,256.62Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "244.96px 250.697px"
    },
    id: "eldmdf8r5s1ki",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.31,256.87c-.07,0,.1-.56.15-1.45a16.35,16.35,0,0,0-.12-3.47,13.53,13.53,0,0,0-1.12-3.26c-.38-.83-.6-1.35-.53-1.38s.39.42.85,1.21a10,10,0,0,1,1.32,3.35,12.14,12.14,0,0,1,0,3.6A2.58,2.58,0,0,1,273.31,256.87Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "272.836px 252.089px"
    },
    id: "elu5rtk29gxqr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,251.29a9.94,9.94,0,0,0-1.36-.77,8.33,8.33,0,0,0-3.72-.31,52.18,52.18,0,0,0-5.34,1,11.39,11.39,0,0,1,5.3-1.5,7.47,7.47,0,0,1,3.91.49C283.78,250.65,284.09,251.27,284,251.29Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "278.797px 250.462px"
    },
    id: "eliv55ylqqbb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.19,253.47a1.23,1.23,0,0,1-.4.07c-.27,0-.66.07-1.17.08a8.25,8.25,0,0,1-4.19-.87,9.37,9.37,0,0,1-2.27-2c-.7-.79-1.43-1.66-2.19-2.58a41.93,41.93,0,0,0-5.28-5.57,14,14,0,0,0-6.76-3.26,10.77,10.77,0,0,0-6,.93,11.22,11.22,0,0,0-3.39,2.43c-.68.73-1,1.2-1,1.17a1.41,1.41,0,0,1,.19-.36,7.57,7.57,0,0,1,.69-.94,10.51,10.51,0,0,1,3.38-2.63A10.87,10.87,0,0,1,251,238.9a14.38,14.38,0,0,1,7,3.34,39.2,39.2,0,0,1,5.32,5.67c1.53,1.81,2.77,3.62,4.27,4.52a8.55,8.55,0,0,0,4,1A15.08,15.08,0,0,1,273.19,253.47Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "256.865px 246.223px"
    },
    id: "elkuv5pq5b8t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.34,376.7s3.86,26.84,4.65,39.41c1,16.22,6.83,41.9,6.83,41.9l15.38,0,.29-60.8,13.7,59.19,17.62-1.59-6.53-65.58L284.2,372.7Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "263.575px 415.355px"
    },
    id: "elptqocwgx0am",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.85,473.6l-1.06-27.92-19.73.58s2.58,18.59,2.15,20.09c-1.8,6.26-10.89,6.58-10.89,6.58-5,.05-4.2,4.44-4.2,4.44l34-.24Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "247.096px 461.525px"
    },
    id: "elp6ille9w85f",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.55,463.79a20.43,20.43,0,0,1-.12-3.28,19,19,0,0,1,.14-3.28,41.44,41.44,0,0,1,0,6.56Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "256.555px 460.51px"
    },
    id: "el7a0e8cym7xs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.26,460.61a13.78,13.78,0,0,1-2.79,0,14.69,14.69,0,0,1-2.78-.23,29.91,29.91,0,0,1,5.57.2Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "256.475px 460.506px"
    },
    id: "eltiugnlybnpo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.64,458.81a15.76,15.76,0,0,1-2.18,2,17.51,17.51,0,0,1-2.36,1.77,16.25,16.25,0,0,1,2.19-2A17.09,17.09,0,0,1,258.64,458.81Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "256.37px 460.695px"
    },
    id: "elkt5jcjeu4co",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.52,463a3.19,3.19,0,0,1-.7-.68c-.4-.45-.92-1.09-1.46-1.82s-1-1.43-1.31-1.94a3.37,3.37,0,0,1-.45-.86,4,4,0,0,1,.61.76c.34.48.82,1.15,1.36,1.88s1,1.38,1.4,1.86A4.73,4.73,0,0,1,258.52,463Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "256.56px 460.35px"
    },
    id: "elkkmk5oeszg9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250,455.69a20.43,20.43,0,0,1-.12-3.28,18.93,18.93,0,0,1,.14-3.28,20.33,20.33,0,0,1,.12,3.28A19,19,0,0,1,250,455.69Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "250.01px 452.41px"
    },
    id: "el83a47u45sa2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.71,452.51a14.72,14.72,0,0,1-2.79,0,15.89,15.89,0,0,1-2.78-.23,27.79,27.79,0,0,1,5.57.2Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "249.925px 452.399px"
    },
    id: "elaj15tg90k6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.09,450.71a15.76,15.76,0,0,1-2.18,2,15.39,15.39,0,0,1-2.36,1.76,17,17,0,0,1,2.19-2A16.22,16.22,0,0,1,252.09,450.71Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "249.82px 452.59px"
    },
    id: "elu1fop1i9h2n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,454.92a3.53,3.53,0,0,1-.7-.68c-.39-.45-.92-1.09-1.46-1.82s-1-1.43-1.31-1.94a3.37,3.37,0,0,1-.45-.86s.26.27.61.75.82,1.16,1.36,1.89,1,1.38,1.4,1.86A3.49,3.49,0,0,1,252,454.92Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "250.04px 452.27px"
    },
    id: "eltzbuqsr3kcc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.92,475.45a21.08,21.08,0,0,1-.13-3.28,19.59,19.59,0,0,1,.15-3.28,41.44,41.44,0,0,1,0,6.56Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "250.922px 472.17px"
    },
    id: "elhy1z20nk79l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.63,472.27a29.91,29.91,0,0,1-5.57-.2,14.19,14.19,0,0,1,2.79,0A15.17,15.17,0,0,1,253.63,472.27Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "250.845px 472.16px"
    },
    id: "el7fuquq67927",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253,470.47a15.76,15.76,0,0,1-2.18,2,16,16,0,0,1-2.36,1.76,16.25,16.25,0,0,1,2.19-2A15.62,15.62,0,0,1,253,470.47Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "250.73px 472.35px"
    },
    id: "eldl99snhirpb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.88,474.68a4.07,4.07,0,0,1-.69-.68c-.4-.45-.92-1.09-1.46-1.82s-1-1.43-1.31-1.94a3.37,3.37,0,0,1-.45-.86,3.6,3.6,0,0,1,.61.76c.34.48.82,1.15,1.36,1.88s1,1.38,1.4,1.86A3.22,3.22,0,0,1,252.88,474.68Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "250.925px 472.03px"
    },
    id: "elvobwsmw6k9n",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.26,473.35l-1.06-27.92-21.42.63s4.26,18.55,3.84,20c-1.8,6.26-10.89,6.58-10.89,6.58-5,.05-4.2,4.44-4.2,4.44l34-.24Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "277.506px 461.255px"
    },
    id: "elp3tml0q1l0l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.75,455.6a21.08,21.08,0,0,1-.13-3.28,19.59,19.59,0,0,1,.15-3.28,41.44,41.44,0,0,1,0,6.56Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "278.752px 452.32px"
    },
    id: "eljhan9uo2h6d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.46,452.42a29.91,29.91,0,0,1-5.57-.2,14.19,14.19,0,0,1,2.79,0A15.17,15.17,0,0,1,281.46,452.42Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "278.675px 452.31px"
    },
    id: "el9hg97eudu3p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.84,450.62a15.76,15.76,0,0,1-2.18,2,16,16,0,0,1-2.36,1.76,32.78,32.78,0,0,1,4.54-3.73Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "278.57px 452.5px"
    },
    id: "el6nyfxji00j3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.71,454.83a4.07,4.07,0,0,1-.69-.68c-.4-.45-.92-1.09-1.46-1.82s-1-1.43-1.31-1.94a3.37,3.37,0,0,1-.45-.86,3.6,3.6,0,0,1,.61.76c.34.48.82,1.15,1.36,1.88s1,1.38,1.4,1.86A3.22,3.22,0,0,1,280.71,454.83Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "278.755px 452.18px"
    },
    id: "elq6h5t8sriu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.43,464.57a20.33,20.33,0,0,1-.12-3.28,19,19,0,0,1,.14-3.28,20.43,20.43,0,0,1,.12,3.28A18.83,18.83,0,0,1,288.43,464.57Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "288.44px 461.29px"
    },
    id: "eloq5t0pnqx87",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.14,461.39a27.79,27.79,0,0,1-5.57-.2,14.82,14.82,0,0,1,2.79,0A15.76,15.76,0,0,1,291.14,461.39Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "288.355px 461.286px"
    },
    id: "el6ebiw1gtjw6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.52,459.59a15.76,15.76,0,0,1-2.18,2,16.82,16.82,0,0,1-2.36,1.77,17,17,0,0,1,2.19-2A17.82,17.82,0,0,1,290.52,459.59Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "288.25px 461.475px"
    },
    id: "elpumxwwh01ma",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.4,463.8a3.19,3.19,0,0,1-.7-.68c-.39-.45-.92-1.08-1.46-1.82s-1-1.42-1.31-1.94a3.37,3.37,0,0,1-.45-.86,3.57,3.57,0,0,1,.61.76c.35.48.82,1.15,1.36,1.88s1,1.39,1.4,1.86A4.08,4.08,0,0,1,290.4,463.8Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "288.44px 461.15px"
    },
    id: "elaxlahpdjzam",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.39,475.69a21.08,21.08,0,0,1-.13-3.28,19.66,19.66,0,0,1,.15-3.29,20.51,20.51,0,0,1,.12,3.29A20.3,20.3,0,0,1,281.39,475.69Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "281.397px 472.405px"
    },
    id: "elzthjvu643fb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.1,472.51a14.72,14.72,0,0,1-2.79,0,14.18,14.18,0,0,1-2.78-.24,15.79,15.79,0,0,1,2.79,0A14.18,14.18,0,0,1,284.1,472.51Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "281.315px 472.392px"
    },
    id: "elxv89mvrq1v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.48,470.71a16.54,16.54,0,0,1-2.18,2,16,16,0,0,1-2.36,1.76,16.25,16.25,0,0,1,2.19-2A15.62,15.62,0,0,1,283.48,470.71Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "281.21px 472.59px"
    },
    id: "elgyvf810hw7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.35,474.91s-.29-.23-.69-.68a22.88,22.88,0,0,1-1.46-1.82c-.55-.73-1-1.42-1.31-1.93a3.57,3.57,0,0,1-.45-.86s.26.27.61.75.82,1.16,1.36,1.89,1,1.38,1.4,1.85A3.71,3.71,0,0,1,283.35,474.91Z",
    style: {
      fill: "rgb(250, 250, 250)",
      transformOrigin: "281.395px 472.265px"
    },
    id: "elsm1lap7zzq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.56,472.69c0,.06-.36.14-.92.32a4.28,4.28,0,0,0-1.92,1.16,4.23,4.23,0,0,0-1,2,7.54,7.54,0,0,1-.19.95c-.06,0-.15-.37-.09-1a3.9,3.9,0,0,1,1-2.22,3.94,3.94,0,0,1,2.14-1.16C264.18,472.62,264.56,472.64,264.56,472.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "262.49px 474.885px"
    },
    id: "elitp99a5vgb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.36,301.26a5.83,5.83,0,0,0-9.83,2.21,6.48,6.48,0,0,0-8.59-3.94c-2.15-2.6-5.56-3.74-8.79-4.75a8.86,8.86,0,0,0-4.44-.59c-2.08.46-3.5,2.31-4.74,4-2.11,2.92-4.28,6-4.57,9.62s2.16,7.65,5.75,7.72a6.11,6.11,0,0,0,9.42,5.18,8.3,8.3,0,0,0,11.37,2.59,6.38,6.38,0,0,0,9.19,2.31c3.08,2.92,13.54,2.31,16.09-1.08l6-27.38C234.47,295.29,223.13,297.44,221.36,301.26Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "209.298px 310.801px"
    },
    id: "elxlyrkfjjni",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218,323.06a3.47,3.47,0,0,1-.2-.88c-.1-.57-.19-1.4-.26-2.44a36.14,36.14,0,0,1,2.65-15.87c.4-.95.76-1.71,1-2.22a3.66,3.66,0,0,1,.47-.77c.08,0-.46,1.2-1.17,3.13a42.63,42.63,0,0,0-2.62,15.72C217.9,321.78,218,323.05,218,323.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "219.572px 311.97px"
    },
    id: "elch2ov4mlqm4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.36,318.34a7,7,0,0,1,0-2.3,39.33,39.33,0,0,1,.87-5.46,44.45,44.45,0,0,1,1.5-5.33,7.55,7.55,0,0,1,1-2.09,15.69,15.69,0,0,1-.6,2.21c-.39,1.35-.87,3.23-1.34,5.32s-.82,4-1,5.39A19.06,19.06,0,0,1,208.36,318.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "209.997px 310.75px"
    },
    id: "elk6mos2us7dt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.14,315.85a9.28,9.28,0,0,1,.37-2.59,47.86,47.86,0,0,1,1.84-6,30.76,30.76,0,0,1,2.75-5.7,6.18,6.18,0,0,1,1.71-2c.06.06-.62.79-1.4,2.18a42,42,0,0,0-2.57,5.69c-.86,2.29-1.53,4.4-2,6A20.14,20.14,0,0,1,196.14,315.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "199.477px 307.705px"
    },
    id: "els14vht54dim",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.17,288.66s-.06-5.45-2.82-6.2-7.32.51-10,1.52c-4.66,1.75-12.46,2.92-17.13,4.67-2,.76-2.77,1.24-3.59,3-.57,1.2.61,4.86.61,4.86-1.92-.46-5.93,2.65-7.68,5.21-1.86,2.72-2.64,6-.11,8.14-3.43,3.47-4,10-2.3,14.57.58,1.52,1.33,1.35,1.45,3,.15,2-1.06,3.45-1.44,5.41-.57,3,.74,8.24,2.88,10.37a13.05,13.05,0,0,0-.95,17.31c-1.59,2.84-3.22,5.76-3.67,9s.52,6.86,3.21,8.68c2.24,1.52,5.14,1.51,7.85,1.45l42.31-1c1.83,0,3.79-.12,5.3-1.16,2.23-1.54,2.72-4.58,3-7.27.47-4.27.59-9.38-2.86-11.92a14.45,14.45,0,0,0-.93-16.36c2.26-1.74,2.52-5.05,2.08-7.87s-1.38-5.67-.8-8.46c.38-1.81,1.37-3.44,1.68-5.26.42-2.39-.38-4.82-.59-7.24-.29-3.31.51-6.65.2-10s-3.83-10.76-7.13-11.22C279.75,291.84,274.66,286.72,271.17,288.66Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "257.323px 330.951px"
    },
    id: "elypf7gqaecp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.56,358.69a8,8,0,0,1-1.69,1.41,12.1,12.1,0,0,1-2.32,1.19,18.83,18.83,0,0,1-3.32.9,51.35,51.35,0,0,1-8.91.49c-3.35,0-7,0-10.91,0-7.75-.09-14.76-.41-19.82-.86-2.53-.22-4.57-.45-6-.63l-1.61-.23a3.5,3.5,0,0,1-.57-.1,4,4,0,0,1,.57,0l1.63.16c1.41.13,3.46.32,6,.5,5.06.39,12.06.67,19.8.75l10.91.07a53.49,53.49,0,0,0,8.87-.41,18.29,18.29,0,0,0,3.29-.84,12.5,12.5,0,0,0,2.31-1.11C285,359.23,285.53,358.65,285.56,358.69Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "257.985px 360.697px"
    },
    id: "elko84s6zxjvc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.2,342a2.82,2.82,0,0,1-.52.17l-1.51.41c-.66.18-1.47.39-2.41.6s-2,.47-3.22.69-2.51.49-3.92.7-2.94.43-4.54.64c-3.2.36-6.74.64-10.46.73s-7.27,0-10.49-.26c-1.61-.14-3.14-.25-4.56-.43s-2.75-.35-3.95-.53-2.3-.38-3.25-.55-1.77-.33-2.43-.48l-1.54-.35a3.12,3.12,0,0,1-.52-.14,2.19,2.19,0,0,1,.54.07l1.54.27c.67.13,1.49.28,2.45.43s2,.34,3.24.49,2.53.34,3.95.48,3,.27,4.55.4c3.21.2,6.75.3,10.46.23s7.24-.36,10.43-.7c1.6-.2,3.12-.37,4.53-.6s2.73-.44,3.92-.66,2.28-.45,3.22-.64,1.76-.37,2.42-.53l1.53-.35A3.78,3.78,0,0,1,284.2,342Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "257.54px 343.987px"
    },
    id: "elodz2ile0za",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.17,288.66a1.24,1.24,0,0,1-.31.15l-.91.39c-.8.32-2,.77-3.42,1.29-2.9,1.06-6.94,2.4-11.5,3.62a71.31,71.31,0,0,1-11.84,2.22c-.77.07-1.47.12-2.08.12s-1.15,0-1.58,0l-1-.07a1.15,1.15,0,0,1-.34-.05,1.3,1.3,0,0,1,.34,0h1c.43,0,1,0,1.57-.06s1.3-.09,2.06-.17a80,80,0,0,0,11.78-2.33c4.54-1.21,8.59-2.51,11.5-3.5l3.46-1.18.94-.32A1.59,1.59,0,0,1,271.17,288.66Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "254.68px 292.555px"
    },
    id: "elsyhg7wu0s0b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.23,302.77a17.25,17.25,0,0,0-.51,1.89,7.52,7.52,0,0,0,.9,5.06l.06.11-.08.11a14.29,14.29,0,0,0-2.46,5.72,15.18,15.18,0,0,0,.43,7.43,13.65,13.65,0,0,0,1.85,3.77l.1.14-.09.15a14.43,14.43,0,0,0-2.11,6.25,15.29,15.29,0,0,0,.38,5.31,19.78,19.78,0,0,0,1.86,4.46s-.09-.08-.22-.26a9.55,9.55,0,0,1-.54-.8,13.87,13.87,0,0,1-1.42-3.32,15.19,15.19,0,0,1-.51-5.43,14.87,14.87,0,0,1,2.13-6.49v.29a14,14,0,0,1-1.94-3.91,15.34,15.34,0,0,1-.4-7.68,14.25,14.25,0,0,1,2.62-5.87v.22a7.68,7.68,0,0,1-.78-5.31,7,7,0,0,1,.47-1.4A1.78,1.78,0,0,1,230.23,302.77Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "229.015px 322.97px"
    },
    id: "elahr47ee855i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.94,379.48s-.1-.06-.27-.21-.42-.37-.73-.68a14.66,14.66,0,0,1-2.24-3.1,15.79,15.79,0,0,1-1.78-5.75,15,15,0,0,1,1.19-7.81v.2a14.08,14.08,0,0,1-2.28-7.87,14.24,14.24,0,0,1,3-8.76l0,.34a14.64,14.64,0,0,1-4.28-12.6,13.76,13.76,0,0,1,.82-3.07,8.25,8.25,0,0,0,.72-2.87,4,4,0,0,0-1.13-2.55,12.19,12.19,0,0,1-1.72-2.46,9.44,9.44,0,0,1-.89-5.69c.32-1.88,1.15-3.52,1.26-5.2s-.67-3.21-1.11-4.78a11.34,11.34,0,0,1-.29-4.64,11.58,11.58,0,0,1,3.6-6.87l0,.17a13,13,0,0,1-1.12-6.83,9.18,9.18,0,0,1,.55-2.42,4.57,4.57,0,0,1-.12.62,16.54,16.54,0,0,0-.27,1.81,13.25,13.25,0,0,0,1.23,6.69l.05.1-.08.08a11.34,11.34,0,0,0-3.42,6.7,11.1,11.1,0,0,0,.31,4.48c.42,1.49,1.29,3.07,1.16,4.92s-1,3.47-1.24,5.25a9,9,0,0,0,.86,5.39,11.66,11.66,0,0,0,1.67,2.36,4.53,4.53,0,0,1,1.25,2.86,8.71,8.71,0,0,1-.75,3.06,13.15,13.15,0,0,0-.79,3,14.14,14.14,0,0,0,4.1,12.15l.17.16-.14.18a14,14,0,0,0-.79,16.09l.06.1,0,.1a14.69,14.69,0,0,0-1.23,7.61,15.66,15.66,0,0,0,1.65,5.67A16.75,16.75,0,0,0,256.94,379.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "252.016px 332.755px"
    },
    id: "elmpsxmy1s56d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.84,324a9.62,9.62,0,0,1-1.48.28c-.95.14-2.34.33-4.05.54-3.43.41-8.18.89-13.44,1.25s-10,.52-13.48.57c-1.72,0-3.12,0-4.09,0a8.18,8.18,0,0,1-1.5-.08,7.89,7.89,0,0,1,1.5-.13l4.08-.17c3.45-.14,8.21-.37,13.46-.72s10-.78,13.43-1.1l4.07-.37A7.36,7.36,0,0,1,270.84,324Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "251.82px 325.317px"
    },
    id: "elno9wnb2b6zr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.66,305.26a10.38,10.38,0,0,1-1.53.36c-1,.21-2.42.48-4.2.79-3.55.61-8.48,1.34-14,1.93s-10.45.93-14,1.09c-1.8.08-3.26.12-4.27.13a10.46,10.46,0,0,1-1.56,0,7.75,7.75,0,0,1,1.55-.17l4.26-.3c3.59-.25,8.55-.65,14-1.23s10.39-1.27,14-1.79l4.22-.61A7.76,7.76,0,0,1,273.66,305.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "253.88px 307.425px"
    },
    id: "elx4b50c5060j",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.84,288.39c4.06-2,16.3.28,18.21,4.41a6.29,6.29,0,0,1,10.61,2.39,7,7,0,0,1,9.27-4.25c2.33-2.81,6-4,9.49-5.13a9.46,9.46,0,0,1,4.79-.64c2.24.49,3.78,2.49,5.12,4.35,2.27,3.15,4.62,6.51,4.93,10.38s-2.33,8.25-6.21,8.33a6.6,6.6,0,0,1-10.17,5.6,9,9,0,0,1-12.26,2.79,6.88,6.88,0,0,1-9.92,2.49,8.5,8.5,0,0,1-12.12-1",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "302.062px 303.143px"
    },
    id: "elvqfv2c1fow",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.4,322.34a2.92,2.92,0,0,1-1-.07,8.23,8.23,0,0,1-2.54-.89,12.7,12.7,0,0,1-5.66-6.67,23.36,23.36,0,0,1-1.3-8.7c0-1.13.08-2,.14-2.67a3.36,3.36,0,0,1,.15-1c.08,0,0,1.4.08,3.63a25.6,25.6,0,0,0,1.41,8.53,13.05,13.05,0,0,0,5.36,6.53A14.37,14.37,0,0,0,286.4,322.34Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "281.14px 312.348px"
    },
    id: "el143u1a3ns9zg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.28,312a11.88,11.88,0,0,1-1.14-2.73,35,35,0,0,1-1.51-7,34.1,34.1,0,0,1,0-7.15,11.86,11.86,0,0,1,.52-2.91,29.19,29.19,0,0,1-.15,2.94,43.83,43.83,0,0,0,.18,7.06,45.07,45.07,0,0,0,1.34,6.94A25.9,25.9,0,0,1,292.28,312Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "290.861px 302.105px"
    },
    id: "ely9i92ht6tte",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.64,308.21a6.59,6.59,0,0,1-1.23-1.84A20.12,20.12,0,0,1,300.16,296a6.9,6.9,0,0,1,.35-2.19,39.06,39.06,0,0,0,.58,7.42A37.78,37.78,0,0,0,303.64,308.21Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "301.886px 301.01px"
    },
    id: "elzm0myvyiszc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.47,312.36c-.08,0-.16-1.27-.64-3.28a76.09,76.09,0,0,0-2.35-7.7c-1.08-2.95-2.17-5.59-3.06-7.45s-1.56-2.94-1.49-3,.23.23.56.71a21,21,0,0,1,1.25,2.12,59.33,59.33,0,0,1,3.23,7.44,54.41,54.41,0,0,1,2.22,7.8,21.65,21.65,0,0,1,.32,2.44A2.86,2.86,0,0,1,316.47,312.36Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "312.727px 301.641px"
    },
    id: "elrcmy8dkvud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.15,288.44a18,18,0,0,0-6.47,8.56,11.43,11.43,0,0,1,6.47-8.56Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "277.915px 292.72px"
    },
    id: "elu3juu940w8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.42,100.86a20.83,20.83,0,0,0-5.94,14.53c0,2.42.42,5-.53,7.17-1,2.37-3.48,4-4,6.59-.37,1.91.47,3.82,1.13,5.65s1.11,4,.06,5.64a19.58,19.58,0,0,1-2.4,2.42c-2,2.28-1.85,5.72-1.54,8.77l28.7-1.22Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "361.458px 126.245px"
    },
    id: "elri3g0ph4pxc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.81,116.65c-1.88-8-3.81-16.33-10.44-21.19-5.9-4.33-12.51-5.37-19.81-4.83-3.59.27-7.61,2.06-10.68,3.94-4.22,2.58-5.89,7.57-7.81,12.12-3.87,9.12-2.95,21.27,0,24.56l38.19,18.61c6.53-3.68,10.92-5.44,12.44-12.78C409.72,132.09,408,121.62,406.81,116.65Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "382.256px 120.18px"
    },
    id: "elpu0sd6h14vp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.7,108.31,372,96.7h0c-7.65-.86-12.8,8.53-13.34,16.21-.59,8.53-1,19,0,25.34,1.94,12.76,11.67,13.31,11.75,13.33l.08,5.17-.07,8.56h0c3.15,10.38,13.67,9.13,26.82,3.74h0l-2.47-60.74Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "377.647px 134.888px"
    },
    id: "elpkewch4kyei",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.43,124a1.65,1.65,0,0,0,1.58,1.67,1.57,1.57,0,0,0,1.7-1.47,1.64,1.64,0,0,0-1.57-1.67A1.58,1.58,0,0,0,362.43,124Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "364.07px 124.1px"
    },
    id: "el0qg72gfxch8p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.84,119.68c.2.21,1.45-.7,3.22-.68s3.05.91,3.25.69-.11-.48-.67-.9A4.61,4.61,0,0,0,364,118a4.38,4.38,0,0,0-2.57.81C360.93,119.19,360.74,119.58,360.84,119.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "364.093px 118.862px"
    },
    id: "eln609wpf5xe",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.5,124a1.65,1.65,0,0,0,1.57,1.67,1.58,1.58,0,0,0,1.71-1.47,1.65,1.65,0,0,0-1.57-1.67A1.58,1.58,0,0,0,378.5,124Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "380.14px 124.1px"
    },
    id: "el3xslm2i8vq6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.06,119.32c.2.22,1.45-.7,3.22-.68s3.06.91,3.25.69-.11-.48-.67-.89a4.46,4.46,0,0,0-2.6-.82,4.31,4.31,0,0,0-2.57.8C377.15,118.84,377,119.22,377.06,119.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "380.317px 118.492px"
    },
    id: "elo3texf5n8m8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.7,131.86a11.64,11.64,0,0,0-2.86-.54c-.45,0-.88-.14-.95-.45a2.17,2.17,0,0,1,.31-1.33l1.35-3.43c1.89-4.88,3.26-8.89,3.06-9s-1.88,3.81-3.77,8.69c-.45,1.21-.89,2.35-1.3,3.45a2.61,2.61,0,0,0-.25,1.77,1.12,1.12,0,0,0,.74.66,3.38,3.38,0,0,0,.76.12A11.89,11.89,0,0,0,371.7,131.86Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "369.931px 124.515px"
    },
    id: "elsn106hllkxg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.32,151.52a32.5,32.5,0,0,0,17.17-4.45s-4.3,8.93-17.1,7.64Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "378.905px 150.954px"
    },
    id: "eloaji3oiyf5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.52,135.2a2.82,2.82,0,0,0-2.35-1.3,3.68,3.68,0,0,0-3.38,1.64,2.3,2.3,0,0,0-.16,1.65c.12.29,0,.15.24.34a6.46,6.46,0,0,0,2.63,1.66,2.77,2.77,0,0,0,2.94-1.06A2.84,2.84,0,0,0,377.52,135.2Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "374.717px 136.583px"
    },
    id: "elgl12id3ruw5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.21,133.18c-.28,0-.31,1.9-2,3.24s-3.7,1.11-3.72,1.37.45.38,1.32.42a4.8,4.8,0,0,0,3.1-1,4.18,4.18,0,0,0,1.53-2.72C377.55,133.65,377.34,133.17,377.21,133.18Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "374.48px 135.696px"
    },
    id: "el3yhu1ktgxtd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.33,113.76c.14.49,1.91.38,4,.76s3.69,1,4,.64c.13-.2-.13-.67-.77-1.17a7,7,0,0,0-6.07-1.07C377.67,113.17,377.27,113.53,377.33,113.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "381.343px 113.957px"
    },
    id: "elc45qzw3hemk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.83,115.8c.41.33,1.68-.32,3.29-.62s3-.27,3.26-.73c.1-.23-.19-.59-.85-.86a5.17,5.17,0,0,0-2.79-.17,5,5,0,0,0-2.48,1.26C360.76,115.19,360.65,115.63,360.83,115.8Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "364.074px 114.597px"
    },
    id: "el6ywxnz1bes",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.23,95.31a2.33,2.33,0,0,1-.05.28l.05,0Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "372.205px 95.45px"
    },
    id: "elhgwcp7z27vd",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.18,95.59l-.78-.3c-2.45-1.18-4.07-2.55-7.73.88a22.94,22.94,0,0,0-4.95,7.38,29.4,29.4,0,0,0-2.62,7.89,34,34,0,0,0,0,9.82c2.13-1.5,3.17-4.1,3.79-6.63s1-5.17,2.17-7.48a20,20,0,0,0-.21,6.49,2.7,2.7,0,0,0,.75,1.59,1.13,1.13,0,0,0,1.59,0,14,14,0,0,1-.2-7.69,39.85,39.85,0,0,1,2.7-7.31,38.42,38.42,0,0,0,.85,13,3.35,3.35,0,0,0,.78,1.68,3.06,3.06,0,0,0,2.66.48,6.28,6.28,0,0,1,2.78-.2A36.87,36.87,0,0,1,372.18,95.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "364.752px 107.628px"
    },
    id: "eltktczv1eot",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.81,158.18c-.72-1-2.16-1.17-3.42-1.2h-.05",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "405.075px 157.58px"
    },
    id: "el63wwk3w295x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.33,140.84c.56-2.31,1.37-4.73.69-7-.62-2.11-2.43-3.78-2.73-6-.26-1.89.69-3.8.36-5.67-.39-2.18-2.35-3.65-3.8-5.32-3-3.5-3.78-14.94-10.41-19.65l-.6,1.17a20.94,20.94,0,0,0-7.15-3.47,36.17,36.17,0,0,0-18.9-.23l-.09.52a28.34,28.34,0,0,0,2.5,15.18,10.43,10.43,0,0,0,2.46,3.56,4.67,4.67,0,0,0,4,1.17,17.37,17.37,0,0,1-3.81-9.83c1.63,3.59,3.3,7.24,6,10.15a15,15,0,0,0,5.51,3.84,11.3,11.3,0,0,0,1,3.16c.92,2,2.09,4,2,6.23s-1.28,3.89-2.13,5.78a18.31,18.31,0,0,0-.14,14.41,192.76,192.76,0,0,0,26-1.21C413.52,145.85,413.76,143.15,414.33,140.84Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "393.401px 121.204px"
    },
    id: "elhylyh1claal",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375,435.43l8.41,33.71-39.93,10.63c-.82-4.06,19.41-17.88,19.41-17.88l-6.18-22.51Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "363.433px 457.6px"
    },
    id: "elwhzmci452eh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el3drdvql17yg"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "373.075px 458.74px"
    },
    className: "animable",
    id: "ely9azloz46ur"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.05,457.09a1.77,1.77,0,0,1,1.65,1.65,1.63,1.63,0,0,1-1.52,1.67,1.86,1.86,0,0,1-1.73-1.75c.05-.86,1-1.77,1.77-1.56",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "373.075px 458.74px"
    },
    id: "elib5i004rcla",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elw35c0eq04b"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "363.383px 472.775px"
    },
    className: "animable",
    id: "elgrksmlubdt6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.4,469.14l-1-3.36-37.91,11.45s-1.57,1.28-1,2.54Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "363.383px 472.775px"
    },
    id: "elrib0hjxrq8r",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M362.38,462.43c.06.2,1.06,0,2.19.43s1.87,1.13,2,1-.44-1.23-1.82-1.69S362.29,462.25,362.38,462.43Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "364.481px 462.932px"
    },
    id: "elsbgz6dkng5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.65,465.72c0,.21.94.33,1.83,1s1.33,1.55,1.52,1.49,0-1.25-1.11-2.08S357.6,465.52,357.65,465.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "359.356px 466.874px"
    },
    id: "elsh8brd2iooo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.69,471.38c.19,0,.19-1.09-.6-2.08s-1.83-1.19-1.87-1,.69.64,1.33,1.46S356.49,471.41,356.69,471.38Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "355.506px 469.808px"
    },
    id: "elbobuo4s2ayw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.21,456.74c.13.16,1-.36,2.07-.57s2.08-.08,2.13-.28-1-.71-2.28-.44S361.07,456.6,361.21,456.74Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "363.303px 456.071px"
    },
    id: "elk1ngod7knfq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.17,451.9c0,.09.82,0,2-.54a9,9,0,0,0,1.91-1.23,10.71,10.71,0,0,0,1-.94,2.55,2.55,0,0,0,.47-.66,1,1,0,0,0-.19-1.11,1.09,1.09,0,0,0-1-.24,2.69,2.69,0,0,0-.72.31,7.27,7.27,0,0,0-1.13.78A7.63,7.63,0,0,0,360,450a3.54,3.54,0,0,0-.72,2c.1,0,.39-.71,1.13-1.71a8,8,0,0,1,1.51-1.52,7,7,0,0,1,1.05-.68c.39-.23.75-.33.91-.16s.07.09,0,.25a2.1,2.1,0,0,1-.35.47,11.17,11.17,0,0,1-.89.92,10.87,10.87,0,0,1-1.73,1.29A15.09,15.09,0,0,0,359.17,451.9Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "361.905px 449.572px"
    },
    id: "el0pyzj6vavwa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.5,452.13a3.56,3.56,0,0,0,0-2.17,7.47,7.47,0,0,0-.87-2.22,8,8,0,0,0-.85-1.13,1.74,1.74,0,0,0-1.56-.72,1,1,0,0,0-.68.8,3.28,3.28,0,0,0,0,.83,5.22,5.22,0,0,0,.37,1.41,5.16,5.16,0,0,0,1.43,1.94c1.07.87,1.94.9,1.94.83s-.74-.34-1.62-1.22a5,5,0,0,1-1.15-1.8,4.83,4.83,0,0,1-.28-1.22c-.06-.46,0-.86.18-.86s.62.19.88.5a7.21,7.21,0,0,1,.79,1,8.21,8.21,0,0,1,.94,2C359.39,451.31,359.39,452.13,359.5,452.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "357.592px 449.007px"
    },
    id: "elrbh313fxkvk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.5,442.79l-.64,34.74-41.32-.12c.26-4.13,23.39-12.22,23.39-12.22l-.11-23.34Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "387.52px 459.69px"
    },
    id: "elxfgbcscpnc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elhzjdl5kcb9d"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "400.579px 464.809px"
    },
    className: "animable",
    id: "elswqzclyemj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401,463.2a1.77,1.77,0,0,1,1.16,2,1.61,1.61,0,0,1-1.9,1.22A1.86,1.86,0,0,1,399,464.3a1.68,1.68,0,0,1,2.12-1.05",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "400.579px 464.809px"
    },
    id: "elxrvwz0svlw",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el2to3j92bdch"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6,
      transformOrigin: "387.192px 475.775px"
    },
    className: "animable",
    id: "el36s8p7k2iau"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.86,477.53l-.09-3.51-39.59,1.2s-1.84.84-1.64,2.19Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "387.192px 475.775px"
    },
    id: "eltyowlccuen",
    className: "animable"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M389.31,465.58c0,.21,1,.31,2,1s1.52,1.57,1.7,1.49-.11-1.3-1.32-2.11S389.27,465.39,389.31,465.58Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "391.184px 466.734px"
    },
    id: "el5cb32wsfwow",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.89,467.53c-.05.2.82.57,1.5,1.46s.88,1.84,1.08,1.84.33-1.21-.54-2.31S383.89,467.33,383.89,467.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "385.252px 469.138px"
    },
    id: "eltc560qcxc3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.49,472.75c.18.05.47-1-.05-2.17S380,469,379.9,469.14s.5.79.91,1.75S381.29,472.73,381.49,472.75Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "380.812px 470.933px"
    },
    id: "elb81vk66mehg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.66,459.78c.08.2,1-.09,2.15,0s2,.46,2.13.28-.75-.93-2.09-1S389.56,459.62,389.66,459.78Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "391.803px 459.582px"
    },
    id: "el3nwsq00iivk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,454.59a3.73,3.73,0,0,0,2.06,0,8.82,8.82,0,0,0,2.17-.69,8.26,8.26,0,0,0,1.19-.66,2.31,2.31,0,0,0,.63-.51.94.94,0,0,0,.1-1.12,1.1,1.1,0,0,0-.88-.49,2.93,2.93,0,0,0-.78.11,8.17,8.17,0,0,0-1.29.46,7.42,7.42,0,0,0-1.91,1.31c-1,.93-1.3,1.72-1.23,1.76s.56-.59,1.54-1.36a8.2,8.2,0,0,1,1.85-1.08,6.37,6.37,0,0,1,1.19-.38c.44-.12.81-.12.93.08s0,.11,0,.24a1.81,1.81,0,0,1-.46.37,9.87,9.87,0,0,1-1.1.65,10.52,10.52,0,0,1-2,.8A11.53,11.53,0,0,0,389,454.59Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "392.145px 452.941px"
    },
    id: "elddpic32diku",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.21,454.89a3.6,3.6,0,0,0,.55-2.09,7.21,7.21,0,0,0-.27-2.38,6.49,6.49,0,0,0-.52-1.31,1.71,1.71,0,0,0-1.32-1.1,1,1,0,0,0-.86.6,3,3,0,0,0-.22.79,5.11,5.11,0,0,0,.87,3.7c.8,1.13,1.64,1.38,1.66,1.31s-.64-.51-1.25-1.59a5.16,5.16,0,0,1-.64-2,4.39,4.39,0,0,1,0-1.25c.07-.46.23-.83.4-.79s.55.35.72.71a7.44,7.44,0,0,1,.5,1.18,8.09,8.09,0,0,1,.4,2.17C389.32,454.07,389.1,454.86,389.21,454.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "388.142px 451.45px"
    },
    id: "el6c016za9j22",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.61,270s-17.28,101.15-15.33,108.53,25,82.58,25,82.58l28.36-8.94L366.81,381s11.69-55.82,11.69-56.74,4.68-41.5,4.68-41.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "357.883px 365.555px"
    },
    id: "elb56a58ede09",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.93,293.64a122.53,122.53,0,0,0-6.63-31.45C414.74,263,372.66,285,372.66,285l8.14,96,4.72,81.78h24.54s3.86-69.78,5-84.53C415,378.18,424.49,312.18,422.93,293.64Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "397.882px 362.485px"
    },
    id: "elxxlqrnx1puo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,381c-.06.05-.67-.65-1.79-1.63a21.82,21.82,0,0,0-4.82-3.17,21.55,21.55,0,0,0-5.5-1.79c-1.46-.26-2.39-.28-2.39-.37a7.09,7.09,0,0,1,2.45,0,17.89,17.89,0,0,1,5.66,1.68,18.12,18.12,0,0,1,4.85,3.37A6.89,6.89,0,0,1,366.81,381Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "359.56px 377.468px"
    },
    id: "elr2ub94hnakp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.05,389.72a2.71,2.71,0,0,1-.76.33,20,20,0,0,1-2.14.62,28.15,28.15,0,0,1-14.61-.51,18.55,18.55,0,0,1-2.1-.77,3,3,0,0,1-.73-.38c0-.08,1.12.32,2.93.79a32.76,32.76,0,0,0,14.43.51C406.91,390,408,389.63,408.05,389.72Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "397.88px 390.198px"
    },
    id: "elgevlygws9fa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.34,298.27a9,9,0,0,0,4.34-2.25,14.88,14.88,0,0,0,2.3-3,12.9,12.9,0,0,0,2.29-6c.12-2.16-1.4-6.41-3.39-7.27-1.16-.51-3.17-.44-3.89.85a14.45,14.45,0,0,0-1.37,4.26c-.23,1.62.39,3.62-.85,4.69-.59.52-1.46.63-2,1.16-1,.95-.61,2.63,0,3.89a25.14,25.14,0,0,0,2.19,3.8",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "332.217px 288.927px"
    },
    id: "el5tq9hnqz38v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.91,298.39a1.74,1.74,0,0,1-.32-.38c-.19-.25-.47-.64-.79-1.16a22,22,0,0,1-1.1-2A5.89,5.89,0,0,1,326,292a2.2,2.2,0,0,1,.85-1.61c.52-.39,1.16-.54,1.64-.87a2.06,2.06,0,0,0,.85-1.52,14.13,14.13,0,0,0,0-2.07,8.21,8.21,0,0,1,.28-2.25,16.11,16.11,0,0,1,.71-2.24,6.64,6.64,0,0,1,.54-1.11,2.37,2.37,0,0,1,1-.85,4.07,4.07,0,0,1,2.58-.16,3.78,3.78,0,0,1,2.08,1.55A10,10,0,0,1,337.7,283a9.49,9.49,0,0,1,.77,4.53,11.63,11.63,0,0,1-1.35,3.93,27.11,27.11,0,0,1-1.92,3,9.29,9.29,0,0,1-4,3.26,8.31,8.31,0,0,1-1.35.42,2,2,0,0,1-.49.06s.66-.16,1.76-.67a9.49,9.49,0,0,0,3.81-3.28,30.68,30.68,0,0,0,1.83-3A11.21,11.21,0,0,0,338,287.5a9.12,9.12,0,0,0-.76-4.28,9.69,9.69,0,0,0-1.11-2.05,3.22,3.22,0,0,0-1.79-1.34,3.56,3.56,0,0,0-2.24.12,1.85,1.85,0,0,0-.81.67,7.3,7.3,0,0,0-.5,1,12,12,0,0,0-1,4.3,15.19,15.19,0,0,1-.05,2.13,2.53,2.53,0,0,1-1.07,1.82c-.59.38-1.2.51-1.64.84a1.77,1.77,0,0,0-.72,1.31,5.51,5.51,0,0,0,.65,2.75c.36.78.7,1.44,1,2C328.57,297.81,328.94,298.37,328.91,298.39Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "332.249px 288.786px"
    },
    id: "el68sjoaxzc8c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.2,284a5,5,0,0,1,2.51.65,1.69,1.69,0,0,1,.55,2.28c-.53.67-1.55.6-2.39.47a4,4,0,0,1,2,.61,1.41,1.41,0,0,1,.43,1.88,1.92,1.92,0,0,1-1.53.53,15.92,15.92,0,0,1-3.64-.33,3.91,3.91,0,0,1-2.37-1.19,1.64,1.64,0,0,1,.25-2.37,3.25,3.25,0,0,1-1.66-2.29c-.17-.95.17-1.31-.52-2-1.27-1.33-1.89-2.59-.84-4.43s3.05-1.88,5.13-3.85l7.29,7.2Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "329.934px 282.195px"
    },
    id: "els4r6xlpzez",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.77,281.86c-5.26,4.82-9.62-1.5-10.11-.47s-1.87,2.68-3.08,2.68-2-.22-1.93-2.13,5.53-8.32,5.53-8.32Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "331.208px 278.845px"
    },
    id: "eloenc03h0psj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.77,281.86a7.39,7.39,0,0,1-.78-.6l-2-1.67c-1.73-1.43-4.14-3.42-6.93-5.79l.34,0a55.75,55.75,0,0,0-4.78,6.55,4.09,4.09,0,0,0-.67,1.85c0,.66.11,1.33.65,1.51a2.84,2.84,0,0,0,.9.13,1.61,1.61,0,0,0,.83-.19,4.64,4.64,0,0,0,1.38-1.16,6.77,6.77,0,0,0,.52-.71,3.72,3.72,0,0,0,.22-.38l.06-.1a.37.37,0,0,1,.16-.17.49.49,0,0,1,.39,0,8.26,8.26,0,0,1,1.52.93,9.42,9.42,0,0,0,2.69,1.32,5.38,5.38,0,0,0,4.19-.57c.9-.55,1.29-.9,1.35-.9a5.07,5.07,0,0,1-1.25,1.07,5.5,5.5,0,0,1-4.38.76,9.54,9.54,0,0,1-2.84-1.32,10.69,10.69,0,0,0-1.4-.85h0s0,0,0,0,.06.06,0,0l-.05.09a3.42,3.42,0,0,1-.23.42,7.79,7.79,0,0,1-.55.77,5.13,5.13,0,0,1-1.53,1.3,2.24,2.24,0,0,1-1.06.25,3.24,3.24,0,0,1-1.08-.17,1.38,1.38,0,0,1-.83-.87,3.3,3.3,0,0,1-.15-1.11,4.49,4.49,0,0,1,.74-2.11,51.12,51.12,0,0,1,4.87-6.6l.15-.19.19.16c2.84,2.48,5.23,4.61,6.89,6.09l1.91,1.73A4,4,0,0,1,338.77,281.86Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "331.134px 278.875px"
    },
    id: "el4tvz8eqqqml",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.69,287a1,1,0,0,0-.34,1.54,3,3,0,0,0,1.51.95,11.56,11.56,0,0,0,5.49,1.05c.6-.07,1.28-.34,1.44-.92s-.47-1.27-1.09-1.59a13,13,0,0,0-4.62-1",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "330.468px 288.779px"
    },
    id: "eleb9yrzvpy4d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.08,287a2.19,2.19,0,0,1,.71,0,14.84,14.84,0,0,1,1.92.2,6.39,6.39,0,0,1,2.73,1.07,1.8,1.8,0,0,1,.55.76,1.14,1.14,0,0,1-.12,1,2.29,2.29,0,0,1-1.8.79,9.38,9.38,0,0,1-3.52-.5,16.52,16.52,0,0,1-2.69-1.08,1.8,1.8,0,0,1-.77-.9,1.32,1.32,0,0,1,0-.89c.21-.48.58-.48.56-.46s-.26.12-.37.53a1.08,1.08,0,0,0,.05.72,1.48,1.48,0,0,0,.68.68,20.64,20.64,0,0,0,2.64.94,9.29,9.29,0,0,0,3.34.44,1.91,1.91,0,0,0,1.42-.55c.26-.36,0-.84-.33-1.16a6.56,6.56,0,0,0-2.49-1.07C330.08,287.18,329.06,287.09,329.08,287Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "330.534px 288.901px"
    },
    id: "elkxylg91w6q8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.93,286.8s.16-.06.44-.07a3.38,3.38,0,0,0,1.08-.22c.39-.17.81-.66.63-1.13s-.85-.72-1.59-.87a20.39,20.39,0,0,0-3.77-.67,14.08,14.08,0,0,1-1.6,0,3,3,0,0,1,1.6-.34,14,14,0,0,1,3.89.53,5.46,5.46,0,0,1,1.11.35,1.57,1.57,0,0,1,.81.87,1.17,1.17,0,0,1-.2,1.09,1.58,1.58,0,0,1-.74.54,2.73,2.73,0,0,1-1.23.08C332.08,286.88,331.93,286.83,331.93,286.8Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "330.853px 285.245px"
    },
    id: "el37slfvmxa2g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.17,292.16q-2-5.79-4-11.56c-1.61-4.62-3.34-9.42-6.84-12.83s-10.59-5.39-14.59-2.58l-3,44.09c-.91,1.13-.31,2.93.86,3.76a7,7,0,0,0,4.15.93,36.49,36.49,0,0,0,17.19-4.43c3.48-1.89,6.86-4.69,7.66-8.57C454.17,298,453.17,295,452.17,292.16Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "438.532px 288.925px"
    },
    id: "el6t27cokhxr2",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.3,267.25c-1.94-14.12-6.41-31.57-6.41-31.57s3.91-21.79,3.07-34.36c-.58-8.7-1.58-24.7-2.14-33.73a9.48,9.48,0,0,0-6.83-8.51l-13.64-4L372.73,160l-14.27,3.13a17.6,17.6,0,0,0-7.62,3.75,28.28,28.28,0,0,0-9,14.43C340,188.42,335.25,231,335.25,231L323,273.47l19.68,11.58s3.55-17.34,4.54-20.59c-2.17,9.93-12.16,48.11-16.09,76.05l37.62,1.43,5.44-14.65,3.26,15L424.13,344S431.63,298.78,427.3,267.25Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "375.823px 249.54px"
    },
    id: "elhl0sz81omf7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,178.33a1.28,1.28,0,0,1-.14.24l-.44.65a22,22,0,0,0-1.54,2.62,36.33,36.33,0,0,0-3.21,10.65,58.33,58.33,0,0,0-.11,16.52,174.06,174.06,0,0,1,1.17,20.36c0,3.61.12,7.14-.1,10.56a79.74,79.74,0,0,1-1.19,9.78c-1.14,6.17-2.53,11.64-3.53,16.26s-1.8,8.38-2.33,11c-.26,1.27-.46,2.27-.61,3-.07.32-.13.57-.17.77a.91.91,0,0,1-.08.27,1,1,0,0,1,0-.28l.12-.78c.12-.73.29-1.73.51-3,.47-2.6,1.18-6.37,2.17-11s2.31-10.13,3.42-16.28a82.9,82.9,0,0,0,1.16-9.72c.2-3.39.11-6.91.08-10.53a180,180,0,0,0-1.13-20.3,58.08,58.08,0,0,1,.22-16.64,35,35,0,0,1,3.4-10.68,19,19,0,0,1,1.63-2.59l.49-.63A1,1,0,0,1,356,178.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "349.855px 229.67px"
    },
    id: "el671b3eolcqm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.72,162.26l-.6-8.49c8.55.45,23.63-1.09,32.8-3.91l1.56,7.72Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "384.3px 156.06px"
    },
    id: "eldrastyllbud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.72,153.63a3.88,3.88,0,0,1,0,.45c0,.32.07.75.12,1.31.09,1.19.22,2.89.38,5.07.34,4.4.74,10.78,1.18,18.66.86,15.76,1.67,37.57,1.36,61.67s-1.73,45.88-3,61.61c-.66,7.87-1.25,14.23-1.71,18.62-.23,2.18-.41,3.87-.54,5.05l-.15,1.32c0,.29-.07.44-.07.44s0-.15,0-.45.05-.75.1-1.32c.1-1.18.25-2.88.43-5.06.41-4.39.94-10.76,1.56-18.63,1.21-15.73,2.55-37.5,2.88-61.59s-.44-45.88-1.21-61.64c-.39-7.88-.74-14.26-1-18.67-.12-2.18-.22-3.88-.29-5.07q0-.84-.06-1.32C376.71,153.78,376.72,153.63,376.72,153.63Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "377.059px 240.73px"
    },
    id: "elkeg3qgki3b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.59,181.76s.26-.09.74,0a3.19,3.19,0,0,1,1.76,1,3.14,3.14,0,0,1,.68,3,3.32,3.32,0,0,1-6.09.8,3.1,3.1,0,0,1-.11-3,3.24,3.24,0,0,1,1.42-1.47,1.34,1.34,0,0,1,.72-.21s-.24.13-.62.38a3.42,3.42,0,0,0-1.19,1.45,2.8,2.8,0,0,0,.19,2.63,2.86,2.86,0,0,0,5.22-.69,2.75,2.75,0,0,0-.51-2.58,3.33,3.33,0,0,0-1.52-1.1A5.07,5.07,0,0,1,384.59,181.76Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "384.568px 184.975px"
    },
    id: "el11s20lkdro1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.59,231s.26-.09.74,0a3.19,3.19,0,0,1,1.76,1.05,3.14,3.14,0,0,1,.68,3,3.32,3.32,0,0,1-6.09.8,3.1,3.1,0,0,1-.11-3,3.24,3.24,0,0,1,1.42-1.47c.44-.22.71-.23.72-.2a7,7,0,0,1-.62.37,3.4,3.4,0,0,0-1.19,1.46,2.78,2.78,0,0,0,.19,2.62,2.86,2.86,0,0,0,5.22-.69,2.75,2.75,0,0,0-.51-2.58,3.33,3.33,0,0,0-1.52-1.1A5.07,5.07,0,0,1,384.59,231Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "384.568px 234.24px"
    },
    id: "elw8d0tnncb19",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.59,280.16s.26-.08.74,0a3.22,3.22,0,0,1,1.76,1.06,3.12,3.12,0,0,1,.68,2.95,3.32,3.32,0,0,1-6.09.8,3.1,3.1,0,0,1-.11-3,3.24,3.24,0,0,1,1.42-1.47c.44-.22.71-.23.72-.2a7,7,0,0,1-.62.37,3.4,3.4,0,0,0-1.19,1.46,2.78,2.78,0,0,0,.19,2.62,2.86,2.86,0,0,0,5.22-.69,2.75,2.75,0,0,0-.51-2.58,3.22,3.22,0,0,0-1.52-1.09C384.85,280.22,384.58,280.21,384.59,280.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "384.564px 283.382px"
    },
    id: "elv72oh9egtsp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el2cgu3lymckf"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "397.035px 225.532px"
    },
    className: "animable",
    id: "elawsgxz8uzjj"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.18,211.29c12.14,12.55,25.92,24.68,42.88,28.87a6.8,6.8,0,0,0,3.34.22,2.55,2.55,0,0,0,2-2.4c-4.86,1.05-12.94-4.45-19.12-7.69-10.68-5.6-19.32-13.42-29.61-19.72",
    id: "elo59q47v43l9",
    className: "animable",
    style: {
      transformOrigin: "397.035px 225.532px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elqx1a2j1amep"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "349.033px 233.46px"
    },
    className: "animable",
    id: "eleml3ysckdm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.82,200.7a37.59,37.59,0,0,0-3,17.42c.4,5.9,1.46,11.74,1.63,17.65.29,9.55-3.23,21.14-2.23,29.79l.48.66C355.17,238.87,351.38,222.57,349.82,200.7Z",
    id: "elrr4x12wf1ic",
    className: "animable",
    style: {
      transformOrigin: "349.033px 233.46px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M401.35,157a5.64,5.64,0,0,1-1.21.61c-.4.19-.91.37-1.49.58s-1.26.44-2,.66a67.36,67.36,0,0,1-12,2.23,97.39,97.39,0,0,1-12.2.48c-1.57,0-2.83-.12-3.7-.2a6.36,6.36,0,0,1-1.35-.18,7.65,7.65,0,0,1,1.36,0c.87,0,2.13.05,3.69,0,3.12,0,7.42-.15,12.15-.63a78.7,78.7,0,0,0,12-2.07c.75-.19,1.43-.38,2-.57s1.1-.34,1.5-.5A7.49,7.49,0,0,1,401.35,157Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "384.375px 159.293px"
    },
    id: "elv4z2hno0dje",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.55,162.16c.05.08-.89.7-2.21,1.94a20.54,20.54,0,0,0-6.23,12.33c-.22,1.79-.16,2.92-.25,2.93a2.18,2.18,0,0,1-.12-.79,12.14,12.14,0,0,1,0-2.18,18.64,18.64,0,0,1,1.94-6.9,18.94,18.94,0,0,1,4.4-5.66,13.88,13.88,0,0,1,1.75-1.3C417.28,162.26,417.53,162.13,417.55,162.16Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "413.121px 170.758px"
    },
    id: "elpb58dq3t22t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.37,166.32a44.13,44.13,0,0,1-1.13,4.73,46.47,46.47,0,0,1-1.09,4.74,14.93,14.93,0,0,1,.59-4.86A15.3,15.3,0,0,1,359.37,166.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "358.253px 171.055px"
    },
    id: "elfkezz68u3xp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,166c-.6,1.37,11.28,74.13,76,107.52a38.38,38.38,0,0,0-1.11-9.1s-48.38-36.64-57-66.86l-9.11-34.91S353.3,163.07,352,166Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "389.989px 218.085px"
    },
    id: "elt2lvve9f3vl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415,159.08s9.11,1.62,11.7,8.67c3.31,9,7.13,30.7,7.91,45.9S424.47,238.14,419,238.36s-49.57-29.5-49.57-29.5L379.66,193l30,14Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "402.04px 198.721px"
    },
    id: "elsfy7f4fgmj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409,184.88a2.28,2.28,0,0,1,0,.38l.06,1.14c0,1,.1,2.49.17,4.38.14,3.83.33,9.36.57,16.24v.29l-.26-.12-30-14,.31-.09L369.66,209l-.07-.35L376,212.9c9.44,6.21,18.49,12,26.87,17.1,4.19,2.5,8.21,4.87,12.12,6.75a22,22,0,0,0,2.93,1.19,4.31,4.31,0,0,0,.73.18l.36,0a2.46,2.46,0,0,0,.37,0l.73-.1.72-.21a14.91,14.91,0,0,0,4.91-2.88,24,24,0,0,0,6-7.78,25.73,25.73,0,0,0,2.35-7.1,22.75,22.75,0,0,0,.36-2.72,15,15,0,0,0,.09-2c0-.52,0-.93,0-1.24a2.24,2.24,0,0,1,0-.42,2.24,2.24,0,0,1,0,.42c0,.31,0,.72,0,1.24a14.37,14.37,0,0,1-.05,2,20.48,20.48,0,0,1-.32,2.74,25,25,0,0,1-2.28,7.2A24.22,24.22,0,0,1,426,235.2a15.36,15.36,0,0,1-5,3l-.75.22c-.25,0-.52.08-.78.12l-.4,0-.42,0a4,4,0,0,1-.79-.18,22.79,22.79,0,0,1-3-1.21c-3.95-1.88-8-4.23-12.18-6.73-8.4-5-17.47-10.86-26.9-17.08l-6.39-4.25-.22-.15.14-.21,10.23-15.85.12-.18.2.09,30,14.09-.25.16c-.18-6.88-.31-12.41-.41-16.25,0-1.89-.06-3.35-.08-4.38,0-.48,0-.86,0-1.14A2.21,2.21,0,0,1,409,184.88Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "401.862px 211.71px"
    },
    id: "el740mgxjxm0e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.59,217.33c-.07,0-.68-.88-1.86-2.23a24.29,24.29,0,0,0-11.64-7.32c-1.72-.48-2.82-.63-2.81-.72a2.39,2.39,0,0,1,.79,0,14.48,14.48,0,0,1,2.12.35A21.46,21.46,0,0,1,424,214.87a14.36,14.36,0,0,1,1.23,1.76C425.5,217.06,425.62,217.31,425.59,217.33Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "417.437px 212.179px"
    },
    id: "el7l8wknijpu5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkh4o01ll5p"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "407.019px 196.12px"
    },
    className: "animable",
    id: "el12r19q3bzmyn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409,184.88a53.4,53.4,0,0,1-4.82,19.61c1.83.77,4,1.51,5.46,2.87.49-.36,0-.71,0-1.31-.36-6.68-.26-14.5-.62-21.17",
    id: "el50zx9xcir9x",
    className: "animable",
    style: {
      transformOrigin: "407.019px 196.12px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elbjve9mn5d1k"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "418.26px 211.64px"
    },
    className: "animable",
    id: "el61gpbsdve1x"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.82,207.14a51.93,51.93,0,0,1,7.38,0,10.08,10.08,0,0,1,3.41.61,9.88,9.88,0,0,1,2.37,1.55c1.62,1.32,3.25,2.89,3.65,4.94a2.23,2.23,0,0,1-.07,1.33,1.1,1.1,0,0,1-1.05.7,1.7,1.7,0,0,1-1-.67c-.66-.71-1.31-1.42-2-2.08-3.28-3.08-8.17-6-12.66-6.35",
    id: "elmego7sleugn",
    className: "animable",
    style: {
      transformOrigin: "418.26px 211.64px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M367.11,204.46c4.79,1.65,5,.32,5,.32l7.32-11.53s-2.95-7.84-3.83-9.23-3.9-8.23-3.9-8.23a4.39,4.39,0,0,0-1.91,3.87c0,2.79,2.24,6.9,2.24,6.9l-7-1.68-9.3-.11s-1.56,1.08,0,2.78h0a2.79,2.79,0,0,0,0,3.19l1.15,1.69s-.62.37-.08,1.53a8.71,8.71,0,0,0,2.69,2.48s-2,1.17-1.23,2.41S367.11,204.46,367.11,204.46Z",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "367.233px 190.538px"
    },
    id: "eljdydo9wz04c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.58,189.56c-.07.14-1.93-.84-4.43-1.36s-4.6-.39-4.61-.55a9.35,9.35,0,0,1,4.72,0A9.45,9.45,0,0,1,364.58,189.56Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "360.06px 188.46px"
    },
    id: "elvu74mdk28l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363,194.23a23.49,23.49,0,0,1-3.19-1,25.19,25.19,0,0,1-3.22-.94,7.29,7.29,0,0,1,3.37.45A7.09,7.09,0,0,1,363,194.23Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "359.795px 193.241px"
    },
    id: "elkrxtof252w",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.53,199.3c-.1.11-.93-.51-1.94-1.24s-1.85-1.34-1.78-1.46,1,.27,2.08,1S362.62,199.2,362.53,199.3Z",
    style: {
      fill: "rgb(235, 153, 110)",
      transformOrigin: "360.672px 197.946px"
    },
    id: "el0h93wpvx7h4s",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.5,443.52l-.85,21.54s21.61,8.1,21.85,12.09L79.66,477l0-33.62Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "100.58px 460.265px"
    },
    id: "elb4umwrqkrm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.72,463.2a1.72,1.72,0,0,0-1.19,1.95,1.64,1.64,0,0,0,1.92,1.19,1.8,1.8,0,0,0,1.25-2.06,1.69,1.69,0,0,0-2.13-1",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "87.1172px 464.781px"
    },
    id: "eltz8495pz7ol",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.66,477l.13-3.39L119.85,475s1.86.81,1.65,2.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "100.588px 475.365px"
    },
    id: "elp0o4rpkd73k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.33,464.85c0,.2-1,.29-2,.95s-1.54,1.51-1.73,1.43.12-1.27,1.35-2S100.37,464.66,100.33,464.85Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "98.4397px 465.963px"
    },
    id: "elbikv1l83x1b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.71,466.68c.05.2-.84.54-1.54,1.4s-.9,1.78-1.1,1.77-.33-1.17.56-2.22S104.71,466.48,104.71,466.68Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "103.318px 468.223px"
    },
    id: "elwzu63s0bsbm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.18,471.94c-.18,0-.46-1,.07-2.1s1.48-1.56,1.57-1.39-.51.77-.93,1.7S107.39,471.92,107.18,471.94Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "107.886px 470.178px"
    },
    id: "eliyn12y8cx1r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.68,443.07l-.85,21.55s21.61,8.09,21.84,12.09l-41.83-.14L120.78,443Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "141.725px 459.855px"
    },
    id: "elnb6ztxxam9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.9,462.76a1.72,1.72,0,0,0-1.19,1.95,1.64,1.64,0,0,0,1.92,1.19,1.81,1.81,0,0,0,1.25-2.07,1.71,1.71,0,0,0-2.14-1",
    style: {
      fill: "rgb(224, 224, 224)",
      transformOrigin: "128.297px 464.337px"
    },
    id: "ellqv6a62wzre",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.84,476.57l.13-3.39,40.06,1.4s1.86.82,1.64,2.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "141.764px 474.945px"
    },
    id: "elg1kt4f0w6na",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.51,464.41c0,.2-1,.29-2,.94s-1.54,1.51-1.73,1.43.12-1.26,1.35-2S141.55,464.22,141.51,464.41Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "139.62px 465.514px"
    },
    id: "el65kb0ou5q3t",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.89,466.24c.05.19-.84.54-1.54,1.4s-.9,1.78-1.1,1.77-.33-1.17.56-2.22S145.89,466,145.89,466.24Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "144.498px 467.775px"
    },
    id: "elt42mprynzpr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.36,471.5c-.18,0-.46-1,.07-2.1s1.48-1.56,1.57-1.39-.51.77-.93,1.69S148.57,471.48,148.36,471.5Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "149.066px 469.738px"
    },
    id: "elfao2u1leky",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,281.13s-1.27,22.68-1.72,28.35,2.69,153.23,2.69,153.23h24.22s8.84-84.91,9.28-98.37,5-51.44,5-51.44V280.06l-38.21,1.28",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "95.8529px 371.385px"
    },
    id: "elpd2vhr6mkof",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.44,311.4c6.4,1.5,7.46,80.71,7.46,80.71l.16,72,24.78.21s3.62-31.55,5-62.64c.89-20.09,2.13-37.32,2.13-37.32s2.47-26,2.65-47.71-2.13-52.26-2.13-52.26L114.67,273Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "132.535px 364.355px"
    },
    id: "el47cqlbwjs34",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.8,290.88a14.83,14.83,0,0,1,.22,3.05c0,1.89,0,4.5-.21,7.38s-.57,5.47-.9,7.33a14.88,14.88,0,0,1-.68,3,21.41,21.41,0,0,1,.32-3c.23-1.87.53-4.45.74-7.32s.32-5.46.36-7.34A21.83,21.83,0,0,1,117.8,290.88Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "117.129px 301.26px"
    },
    id: "el2avbofsfpqx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.48,289.23a5.7,5.7,0,0,1-1,2,15.06,15.06,0,0,1-3.66,3.9,14.84,14.84,0,0,1-4.79,2.36,5.88,5.88,0,0,1-2.18.33,22,22,0,0,0,6.66-3.11A22.27,22.27,0,0,0,89.48,289.23Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "83.665px 293.527px"
    },
    id: "elfwj9zlgfx1m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.12,302.47a7.9,7.9,0,0,1-2.54-.55,17.16,17.16,0,0,1-9.46-7.94,7.9,7.9,0,0,1-1-2.41c.08,0,.46.88,1.29,2.22a19.41,19.41,0,0,0,4,4.64,19.75,19.75,0,0,0,5.26,3.15C149.17,302.16,150.14,302.38,150.12,302.47Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "143.62px 297.02px"
    },
    id: "elg76wokmbbuh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.34,290.12s.09-.15.37-.25a1.79,1.79,0,0,1,1.23,0,2.07,2.07,0,0,1,1.28,1.33,2.06,2.06,0,0,1-3.11,2.14,2.06,2.06,0,0,1-.78-1.67,1.87,1.87,0,0,1,.4-1.16c.19-.22.35-.27.37-.25a2.35,2.35,0,0,0-.4,1.4,1.7,1.7,0,0,0,.69,1.29,1.62,1.62,0,0,0,2.37-1.63,1.76,1.76,0,0,0-1-1.11A2.47,2.47,0,0,0,111.34,290.12Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "112.293px 291.706px"
    },
    id: "eltbhelehix9r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.44,382.16a16.71,16.71,0,0,1-2.11,2.3,60.83,60.83,0,0,1-5.7,4.91,62.48,62.48,0,0,1-6.24,4.21A16.13,16.13,0,0,1,87.62,395a21.52,21.52,0,0,1,2.58-1.74c1.6-1,3.79-2.54,6.12-4.31s4.33-3.5,5.76-4.77A20.81,20.81,0,0,1,104.44,382.16Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "96.03px 388.58px"
    },
    id: "el8eoy69pqad9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.74,374.49a16.18,16.18,0,0,1-1.91,2.39c-1.25,1.42-3,3.32-5.1,5.32s-4,3.73-5.5,4.92a15.62,15.62,0,0,1-2.45,1.83,21.9,21.9,0,0,1,2.21-2.11c1.4-1.26,3.31-3,5.38-5s3.88-3.85,5.19-5.2A19.91,19.91,0,0,1,141.74,374.49Z",
    style: {
      fill: "rgb(69, 90, 100)",
      transformOrigin: "134.26px 381.72px"
    },
    id: "el6g7ddiecrnl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.62,295.16v11.35l2.48,5.8s12.36,6.78,13.76,6.78,1.93-.11,1.72-1.29-4.52-8.17-4.52-8.17l-.43-7s1.08-3,2.37-2.69,3.54,4.52,3.87,5.06,2.58,3,4.62,2.52l-1.18-4.89-4.73-7.85-5.09-4Z",
    style: {
      fill: "rgb(219, 138, 118)",
      transformOrigin: "72.555px 304.935px"
    },
    id: "el3wjrgdyxrz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.47,319a7.54,7.54,0,0,1-1.8-1.53,21.65,21.65,0,0,1-3.37-4.59,21.9,21.9,0,0,1-2.08-5.31,7.61,7.61,0,0,1-.34-2.33,40.5,40.5,0,0,0,2.87,7.39A40.2,40.2,0,0,0,76.47,319Z",
    style: {
      fill: "rgb(164, 91, 74)",
      transformOrigin: "72.6748px 312.12px"
    },
    id: "eleowll8n6d8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.16,316s-.58-.23-1.27-.89A10.85,10.85,0,0,1,66.74,312a19.62,19.62,0,0,1-1.25-3.5,4.34,4.34,0,0,1-.26-1.51,4.77,4.77,0,0,1,.61,1.4c.33.88.76,2.11,1.37,3.38a13.84,13.84,0,0,0,1.94,3C69.76,315.54,70.2,315.91,70.16,316Z",
    style: {
      fill: "rgb(164, 91, 74)",
      transformOrigin: "67.6962px 311.495px"
    },
    id: "ela894bywccwu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.23,301c0,.15-.76.24-1.42.82s-.87,1.31-1,1.29-.11-.23,0-.56a2.29,2.29,0,0,1,1.92-1.66C71,300.82,71.23,300.9,71.23,301Z",
    style: {
      fill: "rgb(164, 91, 74)",
      transformOrigin: "69.9749px 301.987px"
    },
    id: "elh8y6bvk84ju",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,302c.06.13-.45.48-.7,1.15s-.15,1.25-.29,1.31-.55-.64-.19-1.51S65,301.84,65,302Z",
    style: {
      fill: "rgb(164, 91, 74)",
      transformOrigin: "64.3403px 303.209px"
    },
    id: "elrf3hiqijld",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.17,286.17v4.17s-3.71,3.38-4.13,4.23-1.06,7.87-1.06,7.87,2.12,5.25,2.59,5.36,1.81.21,1.57-1.59-1-4.76-1-4.76l2-3.49,1.9,3.59v6.3s-3.81,2.38-3.54,3.34a1.55,1.55,0,0,0,2,1.27,22.9,22.9,0,0,0,3.17-1.17s1.06,2.42,3.07,1.21l2-1.21s1.48,2,2.86,1.55a2.87,2.87,0,0,0,1.79-1.84l2.25-7.76a18.2,18.2,0,0,0,.7-6.14l-.61-10.68Z",
    style: {
      fill: "rgb(219, 138, 118)",
      transformOrigin: "182.675px 299.538px"
    },
    id: "elw7w7xescv6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.65,298.5a6.56,6.56,0,0,1,1.71-2.68c.59-.55,1.52-1,2.16-.5a1.28,1.28,0,0,1,.41,1.26,2.6,2.6,0,0,1-.65,1.21,1.91,1.91,0,0,1,1.85.1,1.27,1.27,0,0,1,.08,1.56,3.65,3.65,0,0,1-1.27,1.1c.42-.31,1.06.13,1.14.64a2.14,2.14,0,0,1-.51,1.46,4.48,4.48,0,0,1-1.58,1.57,1.83,1.83,0,0,1-2.1-.25,1.16,1.16,0,0,1,.41-1.84,1.29,1.29,0,0,1-1.63-.41A2.38,2.38,0,0,1,176,300a4.88,4.88,0,0,1,.64-1.46",
    style: {
      fill: "rgb(255, 190, 157)",
      transformOrigin: "179.22px 299.773px"
    },
    id: "elkuv3we5i5p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.54,301.65a34.38,34.38,0,0,1-.81,5.92,4.19,4.19,0,0,1-.82,2.29,3.69,3.69,0,0,1-1.81.82,5.56,5.56,0,0,0-1.19.38c-.26.13-.39.23-.42.2s.06-.17.31-.37a4.14,4.14,0,0,1,1.19-.56,3.67,3.67,0,0,0,1.57-.8,4.11,4.11,0,0,0,.66-2A35,35,0,0,1,185.54,301.65Z",
    style: {
      fill: "rgb(164, 91, 74)",
      transformOrigin: "183.012px 306.458px"
    },
    id: "elrcphikt9at",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.93,304.15a7.52,7.52,0,0,1-.71,4.27,5.45,5.45,0,0,1-1.78,2.57c-.72.47-1.29.35-1.27.29s.49-.11,1.06-.58a6.55,6.55,0,0,0,1.51-2.47C188.64,306.07,188.78,304.13,188.93,304.15Z",
    style: {
      fill: "rgb(164, 91, 74)",
      transformOrigin: "187.08px 307.745px"
    },
    id: "el90qni06elcl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.75,154S68.62,159,64,174.27s-16.59,73.2-13.48,91.86c0,0,7.16,28.69,8.3,29.68l16.16-5.68,8.82-104.86Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "66.9055px 224.905px"
    },
    id: "el5pm0hbjte0i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.05,151.43l-27-6.54s-29.3,6.57-31.31,9.1-3.14,99.51-4,104.65c-1.09,6.44,0,27.51,0,27.51l77.91,3.25,3.81-12.7-3.81-116.43Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "116.358px 217.145px"
    },
    id: "elendq36t6nw6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.72,286.15S150,230.59,150.84,222.9s1.84-43.47,1.84-43.47l1-19.16a18.9,18.9,0,0,1,11.79,14.5c1.86,11.19,9.64,45.71,9.64,45.71s18.9,58.79,17.66,65.94Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "171.822px 223.345px"
    },
    id: "el0w4j0ivq52ec",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,171.49a1.94,1.94,0,0,1,.08.29c0,.22.11.51.18.86l.28,1.4.24,1.94a49.33,49.33,0,0,1-.35,12.41,145.63,145.63,0,0,1-4.12,18,161.3,161.3,0,0,0-4.75,22c-1.12,7.91-1.7,15.51-2,22.43s-.43,13.16-.51,18.4-.12,9.45-.16,12.42c0,1.44-.06,2.57-.07,3.37,0,.37,0,.66,0,.88a1.16,1.16,0,0,1,0,.3s0-.1,0-.3,0-.51,0-.88c0-.8,0-1.94,0-3.37V269.18c0-5.24.1-11.49.4-18.42s.86-14.55,2-22.48a156.39,156.39,0,0,1,4.8-22.05,151.72,151.72,0,0,0,4.21-17.89A50.86,50.86,0,0,0,87.58,176c-.07-.72-.14-1.37-.19-1.93s-.17-1-.23-1.41-.1-.64-.13-.87A1.14,1.14,0,0,1,87,171.49Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "81.9183px 228.84px"
    },
    id: "elj57t0zz7drf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.43,177.89a4.51,4.51,0,0,1,0,.77c0,.56-.08,1.3-.14,2.22-.14,1.92-.31,4.7-.47,8.14-.34,6.87-.5,16.39-.12,26.89s1.1,20,1.59,26.86c.24,3.39.43,6.16.57,8.13.06.93.1,1.66.14,2.22a4.51,4.51,0,0,1,0,.77,3.92,3.92,0,0,1-.12-.76c-.06-.56-.13-1.29-.23-2.21-.18-2-.43-4.74-.74-8.12-.58-6.87-1.35-16.36-1.74-26.88s-.16-20,.27-26.92c.21-3.44.43-6.22.64-8.14.09-.92.17-1.65.23-2.2A4,4,0,0,1,155.43,177.89Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "155.493px 215.89px"
    },
    id: "el1rt2rs8d86h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,244.53a1.9,1.9,0,0,1-.27.4c-.23.3-.51.65-.84,1.09-.73.94-1.86,2.26-3.31,3.83s-3.26,3.38-5.36,5.28a83.35,83.35,0,0,1-14.93,10.75c-2.47,1.39-4.75,2.54-6.7,3.41s-3.56,1.53-4.69,1.92l-1.3.46a1.37,1.37,0,0,1-.47.12,2.93,2.93,0,0,1,.43-.22l1.27-.55c1.1-.45,2.68-1.15,4.6-2.07s4.18-2.08,6.63-3.48,5-3.09,7.69-5,5-3.86,7.15-5.71,3.94-3.64,5.41-5.18,2.64-2.81,3.42-3.71l.92-1A1.92,1.92,0,0,1,138,244.53Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "119.065px 258.16px"
    },
    id: "el17hsopmghyy",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.79,207.42a1.81,1.81,0,0,1-.11.51c-.11.39-.24.87-.41,1.45-.36,1.25-1,3-1.75,5.23s-1.87,4.75-3.16,7.55S130.5,228,128.7,231s-3.71,5.88-5.51,8.38-3.56,4.66-5.09,6.42-2.8,3.15-3.72,4.07l-1.07,1a2.69,2.69,0,0,1-.39.35s.09-.16.32-.42l1-1.12c.88-1,2.11-2.38,3.59-4.17s3.18-4,5-6.46,3.64-5.31,5.45-8.36,3.35-6.05,4.68-8.81,2.4-5.32,3.24-7.49,1.49-3.93,1.91-5.16c.2-.56.37-1,.5-1.41A1.72,1.72,0,0,1,138.79,207.42Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "125.855px 229.32px"
    },
    id: "elzez1nxn4mz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el458dx9pvpbf"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "81.9918px 236.635px"
    },
    className: "animable",
    id: "elq5jrszt3ln"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.55,192.21C77.39,220.54,74.68,251,76.07,281.06c3.77-3.65,5-9.22,5-14.46s-1.18-10.42-1.4-15.66C78.83,231.06,91.29,211.75,87.55,192.21Z",
    id: "el3qc7d3ybkiw",
    className: "animable",
    style: {
      transformOrigin: "81.9918px 236.635px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "el9ksn1th2ec"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "127.199px 229.465px"
    },
    className: "animable",
    id: "el12c1y8s1tmn"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M137.22,212.18c.32-.92-2.23,14.56-5.75,20.38a42.2,42.2,0,0,1-14.32,14.23S130.46,231.51,137.22,212.18Z",
    id: "el7l8shql9j17",
    className: "animable",
    style: {
      transformOrigin: "127.199px 229.465px"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "elhvw0ehwq1j"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "156.011px 214.93px"
    },
    className: "animable",
    id: "elzarr6ceqd4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.21,184.68s.18,58.18,2.46,61.34c0,0,.63-14.86,1-22.3.69-13.34-1.24-26.67-3.18-39.88",
    id: "elp3jjq8gvk2h",
    className: "animable",
    style: {
      transformOrigin: "156.011px 214.93px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M86,186.67a3.94,3.94,0,0,1-1,0c-.63,0-1.53-.13-2.65-.28a62.27,62.27,0,0,1-8.58-1.78,63.49,63.49,0,0,1-8.27-2.95c-1-.45-1.84-.85-2.4-1.14a4,4,0,0,1-.84-.5,31.55,31.55,0,0,1,3.39,1.3A84.18,84.18,0,0,0,82.39,186,35.07,35.07,0,0,1,86,186.67Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "74.13px 183.361px"
    },
    id: "ely8zqqzn6rz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.68,182.13c0,.14-14.73-.09-32.89-.51s-32.88-.88-32.87-1,14.72.09,32.89.51S153.68,182,153.68,182.13Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "120.8px 181.379px"
    },
    id: "elykopj89xd8a",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.93,189.65a51.84,51.84,0,0,1-6.83,2.65,49.76,49.76,0,0,1-7,2.15,52,52,0,0,1,6.83-2.64A52.42,52.42,0,0,1,168.93,189.65Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "162.015px 192.05px"
    },
    id: "elcb7obke40qc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6,221.51a3.27,3.27,0,0,1-1,.06,27,27,0,0,1-2.72-.11,42.42,42.42,0,0,1-17.12-5.29,26.14,26.14,0,0,1-2.31-1.44,4.6,4.6,0,0,1-.8-.61c.05-.08,1.26.68,3.29,1.73a52.25,52.25,0,0,0,8.25,3.39,51.14,51.14,0,0,0,8.72,1.85C77.18,221.37,78.61,221.42,78.6,221.51Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "66.625px 217.849px"
    },
    id: "eli3ib5m0olvc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134,218.83a2.26,2.26,0,0,1-.53.08l-1.53.13c-1.33.11-3.26.19-5.64.24a124.6,124.6,0,0,1-36.81-5c-2.28-.68-4.12-1.28-5.37-1.74L82.63,212a2.13,2.13,0,0,1-.49-.22,1.73,1.73,0,0,1,.53.12l1.46.44c1.27.4,3.12.95,5.41,1.58a144.75,144.75,0,0,0,18.19,3.73,143.78,143.78,0,0,0,18.51,1.27c2.38,0,4.31,0,5.64-.08l1.53,0A1.91,1.91,0,0,1,134,218.83Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "108.07px 215.537px"
    },
    id: "elnmjfk2ln5yf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.84,212.23a9.73,9.73,0,0,1-2.3.67,58.66,58.66,0,0,1-11.41,1.38,9.92,9.92,0,0,1-2.39-.1,12,12,0,0,1,2.37-.27c1.46-.11,3.48-.29,5.7-.56s4.22-.58,5.66-.81A12.39,12.39,0,0,1,152.84,212.23Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "144.79px 213.27px"
    },
    id: "elwvd0pczjvf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,219.25a12.07,12.07,0,0,1-2.44,1.16c-1.54.63-3.7,1.43-6.13,2.19s-4.67,1.33-6.3,1.68a11.94,11.94,0,0,1-2.66.44,16,16,0,0,1,2.57-.8c1.61-.44,3.81-1.06,6.23-1.82s4.59-1.49,6.16-2A16.46,16.46,0,0,1,174,219.25Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "165.235px 221.985px"
    },
    id: "elreb0ew5l59",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.05,256.4a4.07,4.07,0,0,1-1.1,0c-.71,0-1.73-.1-3-.26a48.07,48.07,0,0,1-18.62-6.43c-1.09-.65-1.94-1.22-2.51-1.64a4.37,4.37,0,0,1-.86-.69c.05-.07,1.35.79,3.55,2a57.38,57.38,0,0,0,9,4A58.32,58.32,0,0,0,72,255.79C74.5,256.19,76.06,256.31,76.05,256.4Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "63.005px 251.907px"
    },
    id: "ela5ej759d1ov",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.15,255.46a2.15,2.15,0,0,1-.52,0l-1.48,0c-1.29,0-3.15,0-5.45,0-4.61-.11-11-.48-17.94-1.32s-13.25-2-17.74-3c-2.25-.5-4.06-.93-5.31-1.26l-1.43-.39a3.48,3.48,0,0,1-.49-.17,1.69,1.69,0,0,1,.52.06l1.45.3c1.26.27,3.08.65,5.33,1.1,4.51.9,10.77,2,17.73,2.84s13.3,1.27,17.89,1.48c2.29.1,4.15.17,5.44.2l1.48.06A1.81,1.81,0,0,1,127.15,255.46Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "101.97px 252.397px"
    },
    id: "elzrwhgd2r2o",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.68,251a3.22,3.22,0,0,1-.92.29c-.6.16-1.48.35-2.57.56a63.82,63.82,0,0,1-8.59,1,62.87,62.87,0,0,1-8.66-.18c-1.1-.1-2-.21-2.6-.31a3.91,3.91,0,0,1-.94-.2,34.26,34.26,0,0,1,3.57.15c2.2.11,5.25.18,8.6,0s6.38-.51,8.56-.83A33.51,33.51,0,0,1,155.68,251Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "143.54px 251.961px"
    },
    id: "el2iyfhg0rgb8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.9,257.16a3.76,3.76,0,0,1-.77.54c-.51.32-1.27.75-2.22,1.25a54.8,54.8,0,0,1-7.74,3.28,53.74,53.74,0,0,1-8.16,2c-1.06.18-1.92.29-2.52.34a3.54,3.54,0,0,1-.94,0,32.93,32.93,0,0,1,3.39-.74,70.48,70.48,0,0,0,15.81-5.3A33.62,33.62,0,0,1,185.9,257.16Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "174.725px 260.881px"
    },
    id: "el24f5ok6no31",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.21,280.48a15,15,0,0,1-2.75,1.26,47.08,47.08,0,0,1-7,2.05,45.59,45.59,0,0,1-7.24.93,14.14,14.14,0,0,1-3-.05,24.75,24.75,0,0,1,3-.32,64.22,64.22,0,0,0,7.16-1.07,65.67,65.67,0,0,0,7-1.89A22.81,22.81,0,0,1,75.21,280.48Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "65.215px 282.628px"
    },
    id: "elg5wuokmj436",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.37,280.82a6.85,6.85,0,0,1-.79.14l-2.29.31c-2,.26-4.87.58-8.44.91-7.14.66-17,1.24-28,1.21s-20.85-.71-28-1.43c-3.57-.35-6.45-.69-8.43-1l-2.29-.33a4.33,4.33,0,0,1-.79-.15,6.12,6.12,0,0,1,.81.05l2.29.23c2,.22,4.88.5,8.45.81,7.13.62,17,1.22,27.94,1.26s20.81-.48,27.95-1.05c3.57-.28,6.46-.54,8.45-.74l2.3-.22A4,4,0,0,1,155.37,280.82Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "115.855px 281.936px"
    },
    id: "elctvbrbs4tsk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.11,159.6c0,.15-15.42-.06-34.43-.46s-34.44-.85-34.43-1,15.42.06,34.44.47S153.12,159.46,153.11,159.6Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "118.68px 158.87px"
    },
    id: "ela2egmaccr6h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.62,286.15a6.57,6.57,0,0,1-1.4-2.93,6.73,6.73,0,0,1-.33-3.23,23.92,23.92,0,0,1,.83,3.09A23.82,23.82,0,0,1,176.62,286.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "175.721px 283.07px"
    },
    id: "el9kpry7ugi74",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184,286.17a21.73,21.73,0,0,1-2.28-6.38,11.5,11.5,0,0,1,1.38,3.1A11.71,11.71,0,0,1,184,286.17Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "182.86px 282.98px"
    },
    id: "el0v3gux11jfml",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.06,294.82a17.44,17.44,0,0,1-1.51-4,18.08,18.08,0,0,1-1-4.13,17.17,17.17,0,0,1,1.52,4A17.72,17.72,0,0,1,64.06,294.82Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "62.805px 290.755px"
    },
    id: "elki2atbodk1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1,292.32a14.92,14.92,0,0,1-1.48-3.61,15.47,15.47,0,0,1-1-3.78,14.46,14.46,0,0,1,1.48,3.61A14.25,14.25,0,0,1,70.1,292.32Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "68.86px 288.625px"
    },
    id: "elyc9xkslf4yi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.68,153.79h0a7,7,0,0,1-.62-3.34l3-43.36c0-12.11,7-22.23,19.06-22l1.11.09a21.65,21.65,0,0,1,19.88,21.61c0,10.49-.16,22.08-.69,27.67-1.09,11.57-12.82,12.42-12.82,12.42l-.56,4.5s.61,7.88-8.58,10.19c-7.07,1.78-14.56-2.91-17.64-5.18A6.84,6.84,0,0,1,109.68,153.79Z",
    style: {
      fill: "rgb(219, 138, 118)",
      transformOrigin: "130.578px 123.525px"
    },
    id: "eluaniktfprgr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.71,146.92a28.19,28.19,0,0,1-14.81-5.68s2.88,8.62,14.52,8.53Z",
    style: {
      fill: "rgb(164, 91, 74)",
      transformOrigin: "131.305px 145.505px"
    },
    id: "eldnohr6h7s27",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.6,117a1.65,1.65,0,0,1-1.73,1.54,1.58,1.58,0,0,1-1.58-1.63,1.66,1.66,0,0,1,1.73-1.54A1.59,1.59,0,0,1,148.6,117Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "146.945px 116.955px"
    },
    id: "elsa4obuaoue",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.17,112.3c-.22.2-1.4-.83-3.18-1s-3.16.64-3.33.41.15-.48.76-.85a4.49,4.49,0,0,1,2.69-.59,4.39,4.39,0,0,1,2.5,1C149.13,111.81,149.28,112.21,149.17,112.3Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "145.909px 111.288px"
    },
    id: "elzjzpv7vrpa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.72,116.06A1.67,1.67,0,0,1,130,117.6a1.59,1.59,0,0,1-1.58-1.63,1.65,1.65,0,0,1,1.73-1.54A1.58,1.58,0,0,1,131.72,116.06Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "130.07px 116.014px"
    },
    id: "elzhujmhwd77l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.65,111.2c-.22.2-1.4-.83-3.18-1s-3.15.65-3.33.41.15-.47.76-.84a4.49,4.49,0,0,1,2.69-.59,4.39,4.39,0,0,1,2.51,1C131.61,110.7,131.76,111.11,131.65,111.2Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "128.388px 110.193px"
    },
    id: "elzki4que35",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,124.92a11.93,11.93,0,0,1,2.93-.28c.46,0,.9-.07,1-.37a2.4,2.4,0,0,0-.19-1.37l-1.06-3.57c-1.47-5.08-2.48-9.24-2.28-9.3s1.56,4,3,9.09l1,3.59a2.62,2.62,0,0,1,.09,1.8,1.16,1.16,0,0,1-.8.61,3.63,3.63,0,0,1-.78,0A11.56,11.56,0,0,1,137,124.92Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "139.304px 117.585px"
    },
    id: "elylli48edbp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.69,125.72c.29,0,.14,1.94,1.68,3.45s3.61,1.46,3.6,1.73-.49.34-1.36.29a4.84,4.84,0,0,1-3-1.33,4.22,4.22,0,0,1-1.28-2.88C131.3,126.16,131.56,125.7,131.69,125.72Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "134.149px 128.462px"
    },
    id: "elekwdy26xfs",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.68,104.26c-.21.47-2,.09-4.08.18s-3.84.51-4.08,0c-.11-.22.22-.65.94-1.06a7.08,7.08,0,0,1,6.22-.18C132.42,103.63,132.78,104,132.68,104.26Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "128.598px 103.628px"
    },
    id: "elyiuosh3ht0m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.94,107.1c-.35.37-1.54-.15-3-.29s-2.75,0-3-.39c-.11-.22.12-.61.7-1a4.38,4.38,0,0,1,4.84.55C149,106.48,149.09,106.91,148.94,107.1Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "145.959px 106.081px"
    },
    id: "eld5s0hwh4glp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113,118.51a3.15,3.15,0,0,0-3.14-3.31c-2.18,0-4.68,1.06-4.9,5.53-.4,7.94,7.65,6.7,7.67,6.48S112.87,121.83,113,118.51Z",
    style: {
      fill: "rgb(219, 138, 118)",
      transformOrigin: "108.975px 121.305px"
    },
    id: "elx2m003d57uf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.06,124.13s-.15.09-.39.19a1.41,1.41,0,0,1-1,0c-.82-.35-1.46-1.72-1.43-3.15a4.58,4.58,0,0,1,.49-2,1.57,1.57,0,0,1,1.09-1,.71.71,0,0,1,.8.42c.09.23,0,.38.07.4s.18-.13.13-.46a.82.82,0,0,0-.28-.51,1.07,1.07,0,0,0-.76-.24,1.94,1.94,0,0,0-1.5,1.16,4.54,4.54,0,0,0-.59,2.19c0,1.6.71,3.14,1.84,3.52a1.49,1.49,0,0,0,1.28-.14C111,124.32,111.08,124.15,111.06,124.13Z",
    style: {
      fill: "rgb(164, 91, 74)",
      transformOrigin: "109.376px 121.256px"
    },
    id: "elqj94j1l2t1m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.12,106.51c.06,1.6,2.32-3.74,1.54-5.16a4.18,4.18,0,1,0,1.47-8.17,3.75,3.75,0,0,0-.52-4.57,5.57,5.57,0,0,0-2.31-1,5.63,5.63,0,0,0-.56-2.85,7,7,0,0,0-10.83-2.47,7,7,0,0,0-11.52,0,6.64,6.64,0,0,0-9.8,2.93,5.17,5.17,0,0,0-6.2.71,19.56,19.56,0,0,1-1.85,2.1,17.33,17.33,0,0,1-2.94,1.32A5.63,5.63,0,0,0,107,97.72a13,13,0,0,0-3.07,2.9,4.48,4.48,0,0,0-.7,4c.61,1.58,2.36,2.52,3,4.11.27.74.27,1.55.53,2.29a4.53,4.53,0,0,0,2.69,2.59c.63,3.23,2.82,4.18,2.85,5.12.28,9.9,4.57,4.33,7.4-16.41.67-4.87-1-7.43,3-10.29a21.77,21.77,0,0,1,1.34,2,6.6,6.6,0,0,0,9.73.72,5.64,5.64,0,0,0,9,1.26c1.38,1.32,4.62,3.6,7.22,1.4A21.32,21.32,0,0,1,152.12,106.51Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "131.048px 101.38px"
    },
    id: "elt0jjratm30e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.17,150.51c-1.38-2-4.84-1.62-7.56-1.33-7.47.78-15.67-.8-21.43-4.84A15.94,15.94,0,0,0,110,142.9c-2.43-1.16-3.53.28-3.77,1.61s-.56,2.68-1,4.84c-1.29,4.3,2.07,8,7.22,10.8s11.61,3.33,17.77,3.23c2.55,0,5.25-.23,7.3-1.49,2.91-1.78,3.58-5.11,4-8.09A4.4,4.4,0,0,0,141.17,150.51Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "123.322px 152.933px"
    },
    id: "el2fy2ty9nzf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.62,153.08a1.89,1.89,0,0,1,.08.5,5.78,5.78,0,0,1-.14,1.46,7.46,7.46,0,0,1-3.08,4.35,10,10,0,0,1-3.45,1.44,23.39,23.39,0,0,1-4.24.48,63.06,63.06,0,0,1-9.72-.21,19.8,19.8,0,0,1-9.16-3.23,15.08,15.08,0,0,1-5-6.16,11.32,11.32,0,0,1-1-5.26c0-.3.06-.58.08-.84s.09-.42.13-.6a1.82,1.82,0,0,1,.14-.49,2,2,0,0,1,0,.51l-.08.6c0,.25,0,.53,0,.83a11.72,11.72,0,0,0,1.12,5.1,15.09,15.09,0,0,0,5,5.92,19.81,19.81,0,0,0,9,3.11,68.94,68.94,0,0,0,9.64.24c2.95-.05,5.65-.5,7.49-1.75a7.39,7.39,0,0,0,3.09-4.09A10.12,10.12,0,0,0,141.62,153.08Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "123.799px 152.964px"
    },
    id: "elce2xcsdiqok",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "eli21zk7griit"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      transformOrigin: "122.291px 154.838px"
    },
    className: "animable",
    id: "el3jortoygc0i"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.94,160.66c-3-.22-7.47-.69-10.22-2-4.93-2.28-7.1-7.27-7.62-12.69l0,1.11a13.34,13.34,0,0,0,3.68,11,18.61,18.61,0,0,0,10.51,5.31,31,31,0,0,0,11.9-.6c2.48-.56,5.15-1.5,6.4-3.71A35.51,35.51,0,0,1,123.94,160.66Z",
    id: "elo5pgrl7bpht",
    className: "animable",
    style: {
      transformOrigin: "122.291px 154.838px"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M112.17,157.48a5.76,5.76,0,0,1-.35-1.76,13.81,13.81,0,0,1,.08-4.37,7.39,7.39,0,0,1,2-3.89,3,3,0,0,1,1.56-.94c0,.08-.58.39-1.29,1.19a8.07,8.07,0,0,0-1.78,3.74,18,18,0,0,0-.22,4.24A6.4,6.4,0,0,1,112.17,157.48Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "113.572px 152px"
    },
    id: "elgdvhwt0kssn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.07,161.54a44,44,0,0,0,1.07-6,42.57,42.57,0,0,0-.3-6.11,15.9,15.9,0,0,1-.77,12.13Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "126.881px 155.495px"
    },
    id: "elpo2e7t4l89m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.59,149.12s.21,0,.51.2a2.78,2.78,0,0,1,.87,1.2,8.25,8.25,0,0,1,.29,4.74,8.75,8.75,0,0,1-2.26,4.19,4,4,0,0,1-1.6,1.15c-.05-.07.57-.5,1.33-1.4a9.59,9.59,0,0,0,2-4,9,9,0,0,0-.13-4.5A3.22,3.22,0,0,0,137.59,149.12Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "137.438px 154.86px"
    },
    id: "eljpnmzi7szsk",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-25",
    className: "animable",
    style: {
      transformOrigin: "250px 477.15px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.68,477.15c0,.15-91.65.26-204.67.26s-204.69-.11-204.69-.26,91.63-.26,204.69-.26S454.68,477,454.68,477.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "250px 477.15px"
    },
    id: "ellz7hntkyg47",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandFam);
export default __webpack_public_path__ + "static/media/LandFam.234e9ac3ac560d97dff3d78fcfd99a36.svg";
export { ForwardRef as ReactComponent };